export const citypairs = {
    pt: [{
        "code": "YXX",
        "name": "Abbotsford",
        "cityCode": "YXX",
        "cityName": "Abbotsford",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "ORD",
        "name": "Aeroporto Internacional O\u0027Hare",
        "cityCode": "CHI",
        "cityName": "Chicago",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "CHS",
        "name": "Aeroporto Internacional de Charleston",
        "cityCode": "CHS",
        "cityName": "Charleston",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "HYA",
        "name": "Aeroporto Municipal de Barnstable",
        "cityCode": "HYA",
        "cityName": "Hyannis",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "PDX",
        "name": "Aeroporto internacional de Portland",
        "cityCode": "PDX",
        "cityName": "Portland",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FRA", "FAO", "LIS", "PDL", "FNC", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "AMS",
        "name": "Amesterdão",
        "cityCode": "AMS",
        "cityName": "Amsterdam",
        "countryCode": "NL",
        "countryName": "Holanda",
        "regionName": "Europa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "BOS", "PDL", "HOR", "FNC", "YYZ", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "SID",
        "name": "Amílcar Cabral International",
        "cityCode": "SID",
        "cityName": "Sal",
        "countryCode": "CV",
        "countryName": "Cabo Verde",
        "regionName": "África",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "BOS", "HOR", "GRW", "OPO", "FLW", "YUL", "LIS", "PDL", "FNC", "YYZ", "PIX", "PVD"],
        "partnerAirport": false
    }, {
        "code": "ARN",
        "name": "Arlanda",
        "cityCode": "STO",
        "cityName": "Stockholm",
        "countryCode": "SE",
        "countryName": "Suécia",
        "regionName": "Europa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "BOS", "HOR", "GRW", "FLW", "YUL", "PDL", "FNC", "YYZ", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YTZ",
        "name": "B. Bish. Toronto City Centre",
        "cityCode": "YTO",
        "cityName": "Toronto",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "AGP", "GRW", "OPO", "SVQ", "FLW", "MAD", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "BWI",
        "name": "Balt./Wash. Internacional",
        "cityCode": "BWI",
        "cityName": "Baltimore",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "BCN",
        "name": "Barcelona",
        "cityCode": "BCN",
        "cityName": "Barcelona",
        "countryCode": "ES",
        "countryName": "Espanha",
        "regionName": "Europa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": true,
        "destinations": ["TER", "YQY", "SAN", "YQX", "LAX", "CVU", "YZF", "YXJ", "GRW", "FLW", "YXT", "YXS", "YFC", "PDL", "YDF", "SFO", "SJZ", "PDX", "SMA", "BOS", "YYF", "HOR", "PSP", "SEA", "YUL", "YQQ", "YMM", "OAK", "FNC", "YYZ", "YCD", "RAI", "YQU", "PIX", "PVD", "LAS"],
        "partnerAirport": false
    }, {
        "code": "BDA",
        "name": "Bermuda",
        "cityCode": "BDA",
        "cityName": "Bermuda",
        "countryCode": "BM",
        "countryName": "Bermudas",
        "regionName": "Europa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "BIO",
        "name": "Bilbao",
        "cityCode": "BIO",
        "cityName": "Bilbao",
        "countryCode": "ES",
        "countryName": "Espanha",
        "regionName": "Europa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "YUL", "SJZ", "CVU", "SMA", "BOS", "PDL", "HOR", "FNC", "YYZ", "GRW"],
        "partnerAirport": false
    }, {
        "code": "BUR",
        "name": "Bob Hope",
        "cityCode": "BUR",
        "cityName": "Burbank",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "BOS",
        "name": "Boston Logan",
        "cityCode": "BOS",
        "cityName": "Boston",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": true,
        "destinations": ["TER", "VXE", "CVU", "MXP", "SNE", "VLC", "GRW", "OPO", "FLW", "ZRH", "LHR", "ORY", "SFL", "PDL", "MUC", "SJZ", "SMA", "AMS", "BIO", "HOR", "LON", "BCN", "BVC", "SID", "MAD", "FCO", "FRA", "FAO", "LIS", "FNC", "CPH", "RAI", "LPA", "ARN", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "SRQ",
        "name": "Bradenton",
        "cityCode": "SRQ",
        "cityName": "Sarasota/ Bradenton",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "BUF",
        "name": "Buffalo Niagara",
        "cityCode": "BUF",
        "cityName": "Buffalo",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "YYC",
        "name": "Calgary",
        "cityCode": "YYC",
        "cityName": "Calgary",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "VXE",
        "name": "Cesária Évora Airport",
        "cityCode": "VXE",
        "cityName": "Mindelo",
        "countryCode": "CV",
        "countryName": "Cabo Verde",
        "regionName": "África",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "BOS", "HOR", "GRW", "OPO", "FLW", "YUL", "LIS", "PDL", "FNC", "YYZ", "PIX", "PVD"],
        "partnerAirport": false
    }, {
        "code": "CLT",
        "name": "Charlotte Douglas",
        "cityCode": "CLT",
        "cityName": "Charlotte",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "YYG",
        "name": "Charlottetown",
        "cityCode": "YYG",
        "cityName": "Charlottetown",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "CHI",
        "name": "Chicago (Todos os Aeroportos)",
        "cityCode": "CHI",
        "cityName": "Chicago",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FRA", "FAO", "LIS", "PDL", "FNC", "MUC", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "MDW",
        "name": "Chicago Midway",
        "cityCode": "CHI",
        "cityName": "Chicago",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FRA", "FAO", "LIS", "PDL", "FNC", "MUC", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "CLE",
        "name": "Cleveland Hopkins",
        "cityCode": "CLE",
        "cityName": "Cleveland",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "YQQ",
        "name": "Comox",
        "cityCode": "YQQ",
        "cityName": "Comox",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "RAI", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "CPH",
        "name": "Copenhaga",
        "cityCode": "CPH",
        "cityName": "Copenhagen",
        "countryCode": "DK",
        "countryName": "Dinamarca",
        "regionName": "Europa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "YUL", "SJZ", "CVU", "SMA", "BOS", "PDL", "HOR", "YYZ", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "CVU",
        "name": "Corvo",
        "cityCode": "CVU",
        "cityName": "Ilha do Corvo (Açores)",
        "countryCode": "PT",
        "countryName": "Portugal",
        "regionName": "Açores",
        "x": 0,
        "y": 0,
        "azores": true,
        "airlineOperated": true,
        "destinations": ["TER", "JAX", "YOW", "MXP", "YXE", "CLT", "YXJ", "SLC", "STT", "DFW", "YXT", "YXS", "STX", "YXX", "TFN", "TFS", "YYC", "SMA", "YYG", "PWM", "YYF", "LGA", "HOR", "YHZ", "LON", "YQB", "YYJ", "BCN", "SMF", "IAD", "SEA", "YQG", "HOU", "MAD", "FCO", "YQM", "YYT", "RSW", "YQQ", "YQR", "YYZ", "LPA", "YQU", "YQT", "ARN", "LGW", "BDA", "YQY", "YQX", "TPA", "YAM", "YZF", "BTV", "PXO", "FLL", "HPN", "VLC", "SVO", "SVQ", "FLW", "ABQ", "HYA", "BUF", "PHL", "VDE", "LHR", "FUE", "SFL", "SFO", "BUR", "PHX", "RDU", "SWF", "ACE", "YSB", "MSP", "YKA", "BVC", "MSY", "LIS", "MCO", "FNC", "PIT", "CPH", "YCD", "PIX", "LAS", "LAX", "CHI", "SPC", "JFK", "OPO", "CHS", "RNO", "BWI", "YTO", "YTS", "MUC", "YDF", "YTZ", "AUS", "MDW", "DCA", "YLW", "BOS", "ROC", "AMS", "PSP", "SYR", "SID", "YUL", "OAK", "YMM", "YEG", "TCI", "ORD", "SAN", "VXE", "ORH", "DTW", "WAS", "SAV", "GRW", "SJC", "MVY", "SRQ", "YVR", "ORY", "YFC", "PDL", "NYC", "EWR", "SJZ", "PDX", "YWG", "BIO", "AGP", "DEN", "RIC", "FRA", "FAO", "RAI", "CLE", "PVD"],
        "partnerAirport": false
    }, {
        "code": "STT",
        "name": "Cyril E. King",
        "cityCode": "STT",
        "cityName": "St. Thomas",
        "countryCode": "VI",
        "countryName": "Ilhas Virgens dos EUA",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "DFW",
        "name": "Dalas/Forth Worth",
        "cityCode": "DFW",
        "cityName": "Dallas/Ft. Worth",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "YDF",
        "name": "Deer Lake",
        "cityCode": "YDF",
        "cityName": "Deer Lake",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "RAI", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "DEN",
        "name": "Denver",
        "cityCode": "DEN",
        "cityName": "Denver",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "DTW",
        "name": "Detroit Wayne County",
        "cityCode": "DTT",
        "cityName": "Detroit",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YEG",
        "name": "Edmonton International",
        "cityCode": "YEA",
        "cityName": "Edmonton",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "FAO",
        "name": "Faro",
        "cityCode": "FAO",
        "cityName": "Faro",
        "countryCode": "PT",
        "countryName": "Portugal",
        "regionName": "Portugal Continental",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "JAX", "YOW", "CHI", "YXE", "CLT", "YXJ", "SLC", "JFK", "CHS", "RNO", "STT", "DFW", "YXT", "YXS", "YTO", "STX", "YXX", "YDF", "YTZ", "AUS", "MDW", "YYC", "YLW", "SMA", "BOS", "PWM", "ROC", "YYF", "HOR", "YHZ", "YQB", "YYJ", "SMF", "SYR", "SEA", "HOU", "YUL", "YQM", "YYT", "RSW", "OAK", "YQQ", "YMM", "YEG", "YQR", "YYZ", "YQU", "YQT", "ORD", "YQY", "SAN", "YQX", "CVU", "ORH", "TPA", "YAM", "YZF", "BTV", "PXO", "DTW", "FLL", "HPN", "SAV", "GRW", "SJC", "FLW", "HYA", "MVY", "BUF", "SRQ", "YVR", "PHL", "YFC", "PDL", "NYC", "BUR", "EWR", "PHX", "SJZ", "RDU", "SWF", "PDX", "YWG", "YSB", "DEN", "RIC", "YKA", "MSY", "MCO", "FNC", "PIT", "YCD", "CLE", "PIX", "LAS"],
        "partnerAirport": false
    }, {
        "code": "FLW",
        "name": "Flores",
        "cityCode": "FLW",
        "cityName": "Ilha das Flores (Açores)",
        "countryCode": "PT",
        "countryName": "Portugal",
        "regionName": "Açores",
        "x": 0,
        "y": 0,
        "azores": true,
        "airlineOperated": true,
        "destinations": ["TER", "JAX", "YOW", "MXP", "YXE", "CLT", "YXJ", "SLC", "STT", "DFW", "YXT", "YXS", "STX", "YXX", "TFN", "TFS", "YYC", "SMA", "YYG", "PWM", "YYF", "LGA", "HOR", "YHZ", "LON", "YQB", "YYJ", "BCN", "SMF", "IAD", "SEA", "YQG", "HOU", "MAD", "FCO", "YQM", "YYT", "RSW", "YQQ", "YQR", "YYZ", "LPA", "YQU", "YQT", "ARN", "LGW", "BDA", "YQY", "YQX", "CVU", "TPA", "YAM", "YZF", "BTV", "PXO", "FLL", "HPN", "VLC", "SVO", "SVQ", "ABQ", "HYA", "BUF", "PHL", "VDE", "LHR", "FUE", "SFL", "SFO", "BUR", "PHX", "RDU", "SWF", "ACE", "YSB", "MSP", "YKA", "BVC", "MSY", "LIS", "MCO", "FNC", "PIT", "CPH", "YCD", "PIX", "LAS", "LAX", "CHI", "SPC", "JFK", "OPO", "CHS", "RNO", "BWI", "YTO", "YTS", "MUC", "YDF", "YTZ", "AUS", "MDW", "DCA", "YLW", "BOS", "ROC", "AMS", "PSP", "SYR", "SID", "YUL", "OAK", "YMM", "YEG", "TCI", "ORD", "SAN", "VXE", "ORH", "DTW", "WAS", "SAV", "GRW", "SJC", "MVY", "SRQ", "YVR", "ORY", "YFC", "PDL", "NYC", "EWR", "SJZ", "PDX", "YWG", "BIO", "AGP", "DEN", "RIC", "FRA", "FAO", "RAI", "CLE", "PVD"],
        "partnerAirport": false
    }, {
        "code": "FLL",
        "name": "Fort Lauderdale",
        "cityCode": "FLL",
        "cityName": "Fort Lauderdale",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YMM",
        "name": "Fort McMurray",
        "cityCode": "YMM",
        "cityName": "Fort McMurray",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "RAI", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YXJ",
        "name": "Fort St John",
        "cityCode": "YXJ",
        "cityName": "Fort St. John",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "RAI", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "FRA",
        "name": "Frankfurt",
        "cityCode": "FRA",
        "cityName": "Frankfurt",
        "countryCode": "DE",
        "countryName": "Alemanha",
        "regionName": "Europa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": true,
        "destinations": ["TER", "MDW", "SAN", "SJZ", "LAX", "CVU", "PDX", "SMA", "BOS", "HOR", "PSP", "BCN", "GRW", "SEA", "FLW", "YUL", "OAK", "PDL", "FNC", "YYZ", "SFO", "PIX", "LAS", "PVD"],
        "partnerAirport": false
    }, {
        "code": "MUC",
        "name": "Franz Josef Strauss",
        "cityCode": "MUC",
        "cityName": "Munich",
        "countryCode": "DE",
        "countryName": "Alemanha",
        "regionName": "Europa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "MDW", "SJZ", "CVU", "SMA", "BOS", "HOR", "GRW", "OPO", "FLW", "YUL", "PDL", "FNC", "YYZ", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YFC",
        "name": "Fredericton",
        "cityCode": "YFC",
        "cityName": "Fredericton",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "RAI", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "FUE",
        "name": "Fuerteventura",
        "cityCode": "FUE",
        "cityName": "Puerto del Rosario",
        "countryCode": "ES",
        "countryName": "Espanha",
        "regionName": "Europa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "FLW", "SJZ", "CVU", "SMA", "PDL", "FNC", "HOR", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "FNC",
        "name": "Funchal",
        "cityCode": "FNC",
        "cityName": "Funchal (Madeira)",
        "countryCode": "PT",
        "countryName": "Portugal",
        "regionName": "Madeira",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": true,
        "destinations": ["TER", "YOW", "LAX", "YXE", "SPC", "YXJ", "OPO", "YXT", "YXS", "YTO", "YXX", "YTS", "MUC", "YDF", "TFN", "YTZ", "TFS", "MDW", "YYC", "YLW", "SMA", "BOS", "AMS", "YYF", "LGA", "HOR", "YHZ", "LON", "YQB", "YYJ", "BGO", "BCN", "PSP", "SEA", "YQG", "MAD", "YUL", "YQM", "YYT", "YQQ", "YMM", "OAK", "YEG", "YQR", "YYZ", "TCI", "LPA", "YQU", "YQT", "ARN", "LGW", "YQY", "SAN", "YQX", "VXE", "CVU", "YAM", "YZF", "FLL", "VLC", "GRW", "SVQ", "FLW", "YVR", "VDE", "FUE", "LHR", "YFC", "PDL", "NYC", "SFO", "EWR", "SJZ", "ACE", "PDX", "YWG", "BIO", "OSL", "YSB", "AGP", "MSP", "YKA", "FRA", "FAO", "LIS", "CPH", "RAI", "YCD", "PIX", "LAS", "PVD"],
        "partnerAirport": false
    }, {
        "code": "YQX",
        "name": "Gander International",
        "cityCode": "YQX",
        "cityName": "Gander",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "RAI", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "GRW",
        "name": "Graciosa",
        "cityCode": "GRW",
        "cityName": "Ilha Graciosa (Açores)",
        "countryCode": "PT",
        "countryName": "Portugal",
        "regionName": "Açores",
        "x": 0,
        "y": 0,
        "azores": true,
        "airlineOperated": true,
        "destinations": ["TER", "JAX", "YOW", "MXP", "YXE", "CLT", "YXJ", "SLC", "STT", "DFW", "YXT", "YXS", "STX", "YXX", "TFN", "TFS", "YYC", "SMA", "YYG", "PWM", "YYF", "LGA", "HOR", "YHZ", "LON", "YQB", "YYJ", "BCN", "SMF", "IAD", "SEA", "YQG", "HOU", "MAD", "FCO", "YQM", "YYT", "RSW", "YQQ", "YQR", "YYZ", "LPA", "YQU", "YQT", "ARN", "LGW", "BDA", "YQY", "YQX", "CVU", "TPA", "YAM", "YZF", "BTV", "PXO", "FLL", "HPN", "VLC", "SVO", "SVQ", "FLW", "ABQ", "HYA", "BUF", "PHL", "VDE", "LHR", "FUE", "SFL", "SFO", "BUR", "PHX", "RDU", "SWF", "ACE", "YSB", "MSP", "YKA", "BVC", "MSY", "LIS", "MCO", "FNC", "PIT", "CPH", "YCD", "PIX", "LAS", "LAX", "CHI", "SPC", "JFK", "OPO", "CHS", "RNO", "BWI", "YTO", "YTS", "MUC", "YDF", "YTZ", "AUS", "MDW", "DCA", "YLW", "BOS", "AMS", "PSP", "SYR", "SID", "YUL", "OAK", "YMM", "YEG", "TCI", "ORD", "SAN", "VXE", "ORH", "DTW", "WAS", "SAV", "SJC", "MVY", "SRQ", "YVR", "ORY", "YFC", "PDL", "NYC", "EWR", "SJZ", "PDX", "YWG", "BIO", "AGP", "DEN", "RIC", "FRA", "FAO", "RAI", "CLE", "PVD"],
        "partnerAirport": false
    }, {
        "code": "YQU",
        "name": "Grande Prairie",
        "cityCode": "YQU",
        "cityName": "Grande Prairie",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "RAI", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YQM",
        "name": "Greater Moncton",
        "cityCode": "YQM",
        "cityName": "Moncton",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "ROC",
        "name": "Greater Rochester",
        "cityCode": "ROC",
        "cityName": "Rochester",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "YHZ",
        "name": "Halifax/Stanfield",
        "cityCode": "YHZ",
        "cityName": "Halifax",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "OTP",
        "name": "Henri Coandă",
        "cityCode": "BUH",
        "cityName": "Bucharest",
        "countryCode": "RO",
        "countryName": "Romênia",
        "regionName": "Europa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["PDL"],
        "partnerAirport": false
    }, {
        "code": "VDE",
        "name": "Hierro",
        "cityCode": "VDE",
        "cityName": "Valverde",
        "countryCode": "ES",
        "countryName": "Espanha",
        "regionName": "Europa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "FLW", "SJZ", "CVU", "SMA", "PDL", "FNC", "HOR", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "HOR",
        "name": "Horta",
        "cityCode": "HOR",
        "cityName": "Ilha do Faial (Açores)",
        "countryCode": "PT",
        "countryName": "Portugal",
        "regionName": "Açores",
        "x": 0,
        "y": 0,
        "azores": true,
        "airlineOperated": true,
        "destinations": ["TER", "JAX", "YOW", "MXP", "YXE", "CLT", "YXJ", "SLC", "STT", "DFW", "YXT", "YXS", "STX", "YXX", "TFN", "TFS", "YYC", "SMA", "YYG", "PWM", "YYF", "LGA", "YHZ", "LON", "YQB", "YYJ", "BCN", "SMF", "IAD", "SEA", "YQG", "HOU", "MAD", "FCO", "YQM", "YYT", "RSW", "YQQ", "YQR", "YYZ", "LPA", "YQU", "YQT", "ARN", "LGW", "BDA", "YQY", "YQX", "CVU", "TPA", "YAM", "YZF", "BTV", "PXO", "HPN", "VLC", "SVO", "SVQ", "FLW", "ABQ", "HYA", "BUF", "PHL", "VDE", "LHR", "FUE", "SFL", "SFO", "BUR", "PHX", "RDU", "SWF", "ACE", "YSB", "MSP", "YKA", "BVC", "MSY", "LIS", "MCO", "FNC", "PIT", "CPH", "YCD", "PIX", "LAS", "LAX", "CHI", "SPC", "JFK", "OPO", "CHS", "RNO", "BWI", "YTO", "YTS", "MUC", "YDF", "YTZ", "AUS", "MDW", "DCA", "YLW", "BOS", "ROC", "AMS", "PSP", "SYR", "SID", "YUL", "OAK", "YMM", "YEG", "TCI", "ORD", "SAN", "VXE", "ORH", "DTW", "WAS", "SAV", "GRW", "SJC", "MVY", "SRQ", "YVR", "ORY", "YFC", "PDL", "NYC", "EWR", "SJZ", "PDX", "YWG", "BIO", "AGP", "DEN", "RIC", "FRA", "FAO", "RAI", "CLE", "PVD"],
        "partnerAirport": false
    }, {
        "code": "HOU",
        "name": "Houston",
        "cityCode": "HOU",
        "cityName": "Houston",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "JAX",
        "name": "Jacksonville",
        "cityCode": "JAX",
        "cityName": "Jacksonville",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "JFK",
        "name": "John F Kennedy",
        "cityCode": "NYC",
        "cityName": "New York",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "YKA",
        "name": "Kamloops",
        "cityCode": "YKA",
        "cityName": "Kamloops",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YLW",
        "name": "Kelowna",
        "cityCode": "YLW",
        "cityName": "Kelowna",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "MSY",
        "name": "L. Armstrong New Orleans",
        "cityCode": "MSY",
        "cityName": "New Orleans",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "SPC",
        "name": "La Palma",
        "cityCode": "SPC",
        "cityName": "Santa Cruz De La Palma",
        "countryCode": "ES",
        "countryName": "Espanha",
        "regionName": "Europa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "PDL", "FNC", "HOR", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "ACE",
        "name": "Lanzarote",
        "cityCode": "ACE",
        "cityName": "Lanzarote",
        "countryCode": "ES",
        "countryName": "Espanha",
        "regionName": "Europa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "PDL", "HOR", "FNC", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "LPA",
        "name": "Las Palmas",
        "cityCode": "LPA",
        "cityName": "Gran Canaria",
        "countryCode": "ES",
        "countryName": "Espanha",
        "regionName": "Europa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": true,
        "destinations": ["TER", "YOW", "LAX", "YXE", "YXJ", "YXT", "YXS", "YTO", "YXX", "YDF", "YTZ", "MDW", "YYC", "YLW", "SMA", "BOS", "YYF", "LGA", "HOR", "YHZ", "YQB", "YYJ", "PSP", "SEA", "YQG", "YUL", "YQM", "YQQ", "YMM", "OAK", "YEG", "YYZ", "YQU", "YQT", "YQY", "SAN", "YQX", "CVU", "YZF", "PXO", "FLL", "GRW", "FLW", "YVR", "YFC", "PDL", "NYC", "SFO", "EWR", "SJZ", "PDX", "YWG", "MSP", "YKA", "LIS", "FNC", "YCD", "RAI", "PIX", "LAS", "PVD"],
        "partnerAirport": false
    }, {
        "code": "LAS",
        "name": "Las Vegas",
        "cityCode": "LAS",
        "cityName": "Las Vegas",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FRA", "FAO", "LIS", "PDL", "FNC", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "FCO",
        "name": "Leonardo Da Vinci",
        "cityCode": "ROM",
        "cityName": "Rome",
        "countryCode": "IT",
        "countryName": "Itália",
        "regionName": "Europa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "FLW", "YUL", "SJZ", "CVU", "SMA", "BOS", "PDL", "HOR", "YYZ", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YYZ",
        "name": "Lester B. Pearson",
        "cityCode": "YTO",
        "cityName": "Toronto",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": true,
        "destinations": ["TER", "VXE", "CVU", "MXP", "VLC", "GRW", "OPO", "SVQ", "FLW", "ZRH", "LHR", "ORY", "PDL", "MUC", "SJZ", "SMA", "AMS", "BIO", "HOR", "AGP", "LON", "BCN", "SID", "MAD", "FCO", "FRA", "FAO", "LIS", "FNC", "CPH", "RAI", "LPA", "ARN", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "LIS",
        "name": "Lisboa",
        "cityCode": "LIS",
        "cityName": "Lisboa",
        "countryCode": "PT",
        "countryName": "Portugal",
        "regionName": "Portugal Continental",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": true,
        "destinations": ["TER", "JAX", "YOW", "YXE", "CLT", "YXJ", "SLC", "STT", "DFW", "YXT", "YXS", "STX", "YXX", "YYC", "SMA", "LGB", "YYG", "PWM", "YYF", "LGA", "HOR", "YHZ", "YQB", "YYJ", "SMF", "IAD", "SEA", "YQG", "HOU", "YQM", "YYT", "RSW", "YQQ", "YQR", "YYZ", "LPA", "YQU", "YQT", "BDA", "YQY", "YQX", "CVU", "TPA", "YAM", "YZF", "BTV", "PXO", "FLL", "HPN", "FLW", "ABQ", "HYA", "BUF", "PHL", "SFO", "BUR", "PHX", "RDU", "SWF", "YSB", "MSP", "YKA", "MSY", "MCO", "FNC", "PIT", "YCD", "PIX", "LAS", "LAX", "CHI", "JFK", "RNO", "BWI", "YTO", "PBI", "YTS", "YDF", "YTZ", "MDW", "DCA", "YLW", "BOS", "ROC", "PSP", "SYR", "YUL", "OAK", "YMM", "YEG", "ORD", "SAN", "VXE", "ORH", "DTW", "WAS", "SAV", "GRW", "SJC", "MVY", "SRQ", "YVR", "YFC", "PDL", "NYC", "EWR", "SJZ", "PDX", "YWG", "DEN", "RIC", "RAI", "CLE", "PVD"],
        "partnerAirport": false
    }, {
        "code": "LON",
        "name": "London (Todos os Aeroportos)",
        "cityCode": "LON",
        "cityName": "London",
        "countryCode": "GB",
        "countryName": "Reino Unido",
        "regionName": "Europa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "YQY", "SAN", "YQX", "LAX", "CVU", "YZF", "YXJ", "GRW", "FLW", "YXT", "YXS", "YFC", "PDL", "YDF", "SFO", "MDW", "SJZ", "PDX", "SMA", "BOS", "YYF", "HOR", "PSP", "SEA", "YUL", "YQQ", "YMM", "OAK", "FNC", "YYZ", "YCD", "RAI", "YQU", "PIX", "LAS", "PVD"],
        "partnerAirport": false
    }, {
        "code": "LGW",
        "name": "Londres - Gatwick",
        "cityCode": "LON",
        "cityName": "London",
        "countryCode": "GB",
        "countryName": "Reino Unido",
        "regionName": "Europa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": true,
        "destinations": ["TER", "YQY", "SAN", "YQX", "LAX", "CVU", "YZF", "YXJ", "GRW", "FLW", "YXT", "YXS", "YFC", "PDL", "YDF", "SFO", "MDW", "SJZ", "PDX", "SMA", "BOS", "YYF", "HOR", "PSP", "SEA", "YUL", "YQQ", "YMM", "OAK", "FNC", "YYZ", "YCD", "RAI", "YQU", "PIX", "LAS", "PVD"],
        "partnerAirport": false
    }, {
        "code": "LHR",
        "name": "Londres - Heathrow",
        "cityCode": "LON",
        "cityName": "London",
        "countryCode": "GB",
        "countryName": "Reino Unido",
        "regionName": "Europa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "BOS", "PDL", "HOR", "FNC", "YYZ", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "LGB",
        "name": "Long Beach /Daugherty Field",
        "cityCode": "LGB",
        "cityName": "Long Beach",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "LIS", "PDL", "OPO"],
        "partnerAirport": false
    }, {
        "code": "LAX",
        "name": "Los Angeles",
        "cityCode": "LAX",
        "cityName": "Los Angeles",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FRA", "LIS", "PDL", "FNC", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "MAD",
        "name": "Madrid Barajas",
        "cityCode": "MAD",
        "cityName": "Madrid",
        "countryCode": "ES",
        "countryName": "Espanha",
        "regionName": "Europa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "BOS", "HOR", "GRW", "FLW", "YUL", "YTO", "PDL", "FNC", "YYZ", "PIX", "YTZ"],
        "partnerAirport": false
    }, {
        "code": "MXP",
        "name": "Malpensa",
        "cityCode": "MIL",
        "cityName": "Milan",
        "countryCode": "IT",
        "countryName": "Itália",
        "regionName": "Europa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "FLW", "YUL", "SJZ", "CVU", "SMA", "BOS", "PDL", "HOR", "YYZ", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "MVY",
        "name": "Martha\u0027s Vineyard",
        "cityCode": "MVY",
        "cityName": "Marthas Vineyard",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "OAK",
        "name": "Metropolitan Oakland",
        "cityCode": "OAK",
        "cityName": "Oakland",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": true,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FRA", "FAO", "LIS", "PDL", "FNC", "RAI", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "MSP",
        "name": "Minneapolis-St Paul International/Wold-Chamberlain",
        "cityCode": "MSP",
        "cityName": "Minneapolis",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YUL",
        "name": "Montreal-Pierre E.Trud.",
        "cityCode": "YMQ",
        "cityName": "Montreal",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": true,
        "destinations": ["TER", "VXE", "CVU", "MXP", "VLC", "GRW", "OPO", "SVQ", "FLW", "ZRH", "ORY", "PDL", "MUC", "SJZ", "SMA", "BIO", "HOR", "AGP", "BCN", "SID", "MAD", "FCO", "FRA", "FAO", "LIS", "FNC", "CPH", "RAI", "LPA", "LGW", "ARN", "PIX"],
        "partnerAirport": false
    }, {
        "code": "AGP",
        "name": "Málaga",
        "cityCode": "AGP",
        "cityName": "Malaga",
        "countryCode": "ES",
        "countryName": "Espanha",
        "regionName": "Europa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "FLW", "YUL", "YTO", "PDL", "FNC", "YYZ", "PIX", "YTZ"],
        "partnerAirport": false
    }, {
        "code": "YCD",
        "name": "Nanaimo",
        "cityCode": "YCD",
        "cityName": "Nanaimo",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "RAI", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "NYC",
        "name": "New York (Todos os Aeroportos)",
        "cityCode": "NYC",
        "cityName": "New York",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "EWR",
        "name": "Newark",
        "cityCode": "NYC",
        "cityName": "New York",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "SJC",
        "name": "Norman Y. Mineta San Jose",
        "cityCode": "SJC",
        "cityName": "San Jose",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "LGA",
        "name": "Nova Iorque - LaGuardia",
        "cityCode": "NYC",
        "cityName": "New York",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "MCO",
        "name": "Orlando International",
        "cityCode": "ORL",
        "cityName": "Orlando",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "OSL",
        "name": "Oslo Gardermoen",
        "cityCode": "OSL",
        "cityName": "Oslo",
        "countryCode": "NO",
        "countryName": "Noruega",
        "regionName": "Europa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["PDL", "FNC"],
        "partnerAirport": false
    }, {
        "code": "YOW",
        "name": "Ottawa Macdonald-Cartier",
        "cityCode": "YOW",
        "cityName": "Ottawa",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "PSP",
        "name": "Palm Springs",
        "cityCode": "PSP",
        "cityName": "Palm Springs",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FRA", "LIS", "PDL", "FNC", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "ORY",
        "name": "Paris Orly",
        "cityCode": "PAR",
        "cityName": "Paris",
        "countryCode": "FR",
        "countryName": "França",
        "regionName": "Europa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "YUL", "SJZ", "CVU", "SMA", "BOS", "PDL", "HOR", "YYZ", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YYF",
        "name": "Penticton",
        "cityCode": "YYF",
        "cityName": "Penticton",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "RAI", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "PHL",
        "name": "Philadelphia",
        "cityCode": "PHL",
        "cityName": "Philadelphia",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "PHX",
        "name": "Phoenix Sky Harbor",
        "cityCode": "PHX",
        "cityName": "Phoenix",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "PIX",
        "name": "Pico",
        "cityCode": "PIX",
        "cityName": "Ilha do Pico (Açores)",
        "countryCode": "PT",
        "countryName": "Portugal",
        "regionName": "Açores",
        "x": 0,
        "y": 0,
        "azores": true,
        "airlineOperated": true,
        "destinations": ["TER", "JAX", "YOW", "MXP", "YXE", "CLT", "YXJ", "SLC", "STT", "DFW", "YXT", "YXS", "STX", "YXX", "TFN", "TFS", "YYC", "SMA", "YYG", "PWM", "YYF", "LGA", "HOR", "YHZ", "LON", "YQB", "YYJ", "BCN", "SMF", "IAD", "SEA", "YQG", "HOU", "MAD", "FCO", "YQM", "YYT", "RSW", "YQQ", "YQR", "YYZ", "LPA", "YQU", "YQT", "ARN", "LGW", "BDA", "YQY", "YQX", "CVU", "TPA", "YAM", "YZF", "BTV", "PXO", "FLL", "HPN", "VLC", "SVO", "SVQ", "FLW", "ABQ", "HYA", "BUF", "PHL", "VDE", "LHR", "FUE", "SFL", "SFO", "BUR", "PHX", "RDU", "SWF", "ACE", "YSB", "MSP", "YKA", "BVC", "MSY", "LIS", "FNC", "PIT", "CPH", "YCD", "LAS", "LAX", "CHI", "SPC", "JFK", "OPO", "CHS", "RNO", "BWI", "YTO", "YTS", "MUC", "YDF", "YTZ", "AUS", "MDW", "DCA", "YLW", "BOS", "ROC", "AMS", "PSP", "SYR", "SID", "YUL", "OAK", "YMM", "YEG", "TCI", "ORD", "SAN", "VXE", "ORH", "DTW", "WAS", "SAV", "GRW", "SJC", "MVY", "SRQ", "YVR", "ORY", "YFC", "PDL", "NYC", "EWR", "SJZ", "PDX", "YWG", "BIO", "AGP", "DEN", "RIC", "FRA", "FAO", "RAI", "CLE", "PVD"],
        "partnerAirport": false
    }, {
        "code": "PIT",
        "name": "Pittsburgo",
        "cityCode": "PIT",
        "cityName": "Pittsburgh",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "PDL",
        "name": "Ponta Delgada",
        "cityCode": "PDL",
        "cityName": "Ilha de São Miguel (Açores)",
        "countryCode": "PT",
        "countryName": "Portugal",
        "regionName": "Açores",
        "x": 0,
        "y": 0,
        "azores": true,
        "airlineOperated": true,
        "destinations": ["TER", "JAX", "YOW", "MXP", "YXE", "CLT", "OTP", "YXJ", "SLC", "STT", "DFW", "YXT", "YXS", "STX", "YXX", "TFN", "TFS", "YYC", "SMA", "LGB", "YYG", "PWM", "YYF", "LGA", "HOR", "YHZ", "LON", "YQB", "YYJ", "BCN", "SMF", "IAD", "SEA", "YQG", "HOU", "MAD", "FCO", "YQM", "YYT", "RSW", "YQQ", "YQR", "YYZ", "LPA", "YQU", "YQT", "ARN", "LGW", "BDA", "YQY", "YQX", "CVU", "TPA", "YAM", "YZF", "BTV", "PXO", "FLL", "HPN", "VLC", "SVO", "SVQ", "FLW", "ABQ", "HYA", "BUF", "PHL", "VDE", "LHR", "FUE", "SFL", "SFO", "BUR", "PHX", "RDU", "SWF", "ACE", "YSB", "MSP", "YKA", "BVC", "MSY", "LIS", "MCO", "FNC", "PIT", "CPH", "YCD", "PIX", "LAX", "CHI", "SPC", "JFK", "OPO", "CHS", "RNO", "BWI", "YTO", "PBI", "YTS", "MUC", "YDF", "YTZ", "AUS", "MDW", "DCA", "YLW", "BOS", "ROC", "AMS", "PSP", "SYR", "SID", "YUL", "OAK", "YMM", "YEG", "TCI", "ORD", "SAN", "VXE", "ORH", "DTW", "WAS", "SAV", "GRW", "SJC", "MVY", "SRQ", "YVR", "ORY", "YFC", "NYC", "EWR", "SJZ", "PDX", "YWG", "BIO", "OSL", "AGP", "DEN", "RIC", "FRA", "FAO", "RAI", "CLE", "PVD"],
        "partnerAirport": false
    }, {
        "code": "PWM",
        "name": "Portland Jetport",
        "cityCode": "PWM",
        "cityName": "Portland",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "OPO",
        "name": "Porto",
        "cityCode": "OPO",
        "cityName": "Porto",
        "countryCode": "PT",
        "countryName": "Portugal",
        "regionName": "Portugal Continental",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": true,
        "destinations": ["TER", "JAX", "YOW", "YXE", "CLT", "YXJ", "SLC", "STT", "DFW", "YXT", "YXS", "STX", "YXX", "YYC", "SMA", "LGB", "YYG", "PWM", "YYF", "LGA", "HOR", "YHZ", "YQB", "YYJ", "SMF", "IAD", "SEA", "YQG", "HOU", "YQM", "YYT", "RSW", "YQQ", "YQR", "YYZ", "YQU", "YQT", "BDA", "YQY", "YQX", "CVU", "TPA", "YAM", "YZF", "BTV", "PXO", "FLL", "HPN", "SVO", "FLW", "ABQ", "HYA", "BUF", "PHL", "SFO", "BUR", "PHX", "RDU", "SWF", "YSB", "MSP", "YKA", "MSY", "MCO", "FNC", "PIT", "YCD", "PIX", "LAS", "LAX", "CHI", "JFK", "CHS", "RNO", "BWI", "YTO", "PBI", "YTS", "MUC", "YDF", "YTZ", "MDW", "DCA", "YLW", "BOS", "ROC", "PSP", "SYR", "YUL", "OAK", "YMM", "YEG", "ORD", "SAN", "VXE", "ORH", "DTW", "WAS", "SAV", "GRW", "SJC", "MVY", "SRQ", "YVR", "YFC", "PDL", "NYC", "EWR", "SJZ", "PDX", "YWG", "DEN", "RIC", "RAI", "CLE", "PVD"],
        "partnerAirport": false
    }, {
        "code": "PXO",
        "name": "Porto Santo",
        "cityCode": "PXO",
        "cityName": "Porto Santo (Madeira)",
        "countryCode": "PT",
        "countryName": "Portugal",
        "regionName": "Madeira",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "RAI",
        "name": "Praia International",
        "cityCode": "RAI",
        "cityName": "Praia",
        "countryCode": "CV",
        "countryName": "Cabo Verde",
        "regionName": "África",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": true,
        "destinations": ["TER", "YQY", "YQX", "CVU", "YZF", "YXJ", "GRW", "OPO", "FLW", "YXT", "YXS", "YFC", "PDL", "YDF", "SJZ", "SMA", "BOS", "YYF", "HOR", "BCN", "YUL", "FRA", "LIS", "YQQ", "YMM", "OAK", "FNC", "YYZ", "YCD", "YQU", "LPA", "LGW", "PIX", "PVD"],
        "partnerAirport": false
    }, {
        "code": "SNE",
        "name": "Preguiça",
        "cityCode": "SNE",
        "cityName": "Sao Nicolau",
        "countryCode": "CV",
        "countryName": "Cabo Verde",
        "regionName": "África",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["BOS"],
        "partnerAirport": false
    }, {
        "code": "YXS",
        "name": "Prince George",
        "cityCode": "YXS",
        "cityName": "Prince George",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "RAI", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "PVD",
        "name": "Providence-T. F. Green",
        "cityCode": "PVD",
        "cityName": "Providence",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": true,
        "destinations": ["TER", "SJZ", "VXE", "CVU", "SMA", "HOR", "BCN", "GRW", "SID", "OPO", "FLW", "FRA", "LIS", "PDL", "FNC", "RAI", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YQB",
        "name": "Quebec",
        "cityCode": "YQB",
        "cityName": "Quebec",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "BVC",
        "name": "Rabil",
        "cityCode": "BVC",
        "cityName": "Boa Vista",
        "countryCode": "CV",
        "countryName": "Cabo Verde",
        "regionName": "África",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "FLW", "SJZ", "CVU", "SMA", "BOS", "PDL", "HOR", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "RDU",
        "name": "Raleigh/Durham",
        "cityCode": "RDU",
        "cityName": "Raleigh/Durham",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "YQR",
        "name": "Regina",
        "cityCode": "YQR",
        "cityName": "Regina",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "RNO",
        "name": "Reno-Tahoe",
        "cityCode": "RNO",
        "cityName": "Reno",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "RIC",
        "name": "Richmond internacional",
        "cityCode": "RIC",
        "cityName": "Richmond",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "DCA",
        "name": "Ronald Reagan Washington",
        "cityCode": "WAS",
        "cityName": "Washington",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "SMF",
        "name": "Sacramento International",
        "cityCode": "SAC",
        "cityName": "Sacramento",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "SLC",
        "name": "Salt Lake City",
        "cityCode": "SLC",
        "cityName": "Salt Lake City",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "SAN",
        "name": "San Diego",
        "cityCode": "SAN",
        "cityName": "San Diego",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FRA", "FAO", "LIS", "PDL", "FNC", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "SMA",
        "name": "Santa Maria",
        "cityCode": "SMA",
        "cityName": "Ilha de Santa Maria (Açores)",
        "countryCode": "PT",
        "countryName": "Portugal",
        "regionName": "Açores",
        "x": 0,
        "y": 0,
        "azores": true,
        "airlineOperated": true,
        "destinations": ["TER", "JAX", "YOW", "MXP", "YXE", "CLT", "YXJ", "SLC", "STT", "DFW", "YXT", "YXS", "STX", "YXX", "TFN", "TFS", "YYC", "YYG", "PWM", "YYF", "LGA", "HOR", "YHZ", "LON", "YQB", "YYJ", "BCN", "SMF", "IAD", "SEA", "YQG", "HOU", "MAD", "FCO", "YQM", "YYT", "RSW", "YQQ", "YQR", "YYZ", "LPA", "YQU", "YQT", "ARN", "LGW", "BDA", "YQY", "YQX", "CVU", "TPA", "YAM", "YZF", "BTV", "PXO", "FLL", "HPN", "VLC", "SVO", "SVQ", "FLW", "ABQ", "HYA", "BUF", "PHL", "VDE", "LHR", "FUE", "SFL", "SFO", "BUR", "PHX", "RDU", "SWF", "ACE", "YSB", "MSP", "YKA", "BVC", "MSY", "LIS", "MCO", "FNC", "PIT", "CPH", "YCD", "PIX", "LAS", "LAX", "CHI", "SPC", "JFK", "OPO", "CHS", "RNO", "BWI", "YTO", "YTS", "MUC", "YDF", "YTZ", "AUS", "MDW", "DCA", "YLW", "BOS", "ROC", "AMS", "PSP", "SYR", "SID", "YUL", "OAK", "YMM", "YEG", "TCI", "ORD", "SAN", "VXE", "ORH", "DTW", "WAS", "SAV", "GRW", "SJC", "MVY", "SRQ", "YVR", "ORY", "YFC", "PDL", "NYC", "EWR", "SJZ", "PDX", "YWG", "BIO", "AGP", "DEN", "RIC", "FRA", "FAO", "RAI", "CLE", "PVD"],
        "partnerAirport": false
    }, {
        "code": "YXE",
        "name": "Saskatoon",
        "cityCode": "YXE",
        "cityName": "Saskatoon",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YAM",
        "name": "Sault Ste. Marie",
        "cityCode": "YAM",
        "cityName": "Sault Ste. Marie",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "PIX"],
        "partnerAirport": false
    }, {
        "code": "SAV",
        "name": "Savannah/Hilton Head",
        "cityCode": "SAV",
        "cityName": "Savannah",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "SEA",
        "name": "Seattle/Tacoma",
        "cityCode": "SEA",
        "cityName": "Seattle",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FRA", "FAO", "LIS", "PDL", "FNC", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "SVQ",
        "name": "Sevilha",
        "cityCode": "SVQ",
        "cityName": "Seville",
        "countryCode": "ES",
        "countryName": "Espanha",
        "regionName": "Europa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "FLW", "YUL", "YTO", "PDL", "FNC", "YYZ", "PIX", "YTZ"],
        "partnerAirport": false
    }, {
        "code": "SVO",
        "name": "Sheremetyevo",
        "cityCode": "MOW",
        "cityName": "Moscow",
        "countryCode": "RU",
        "countryName": "Rússia",
        "regionName": "Europa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "RSW",
        "name": "Southwest Florida International",
        "cityCode": "FMY",
        "cityName": "Fort Myers",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "STX",
        "name": "St. Croix",
        "cityCode": "STX",
        "cityName": "Saint Croix",
        "countryCode": "VI",
        "countryName": "Ilhas Virgens dos EUA",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "YYT",
        "name": "St. John\u0027s",
        "cityCode": "YYT",
        "cityName": "St. Johns",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "PIX"],
        "partnerAirport": false
    }, {
        "code": "SWF",
        "name": "Stewart",
        "cityCode": "SWF",
        "cityName": "Newburgh",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "YSB",
        "name": "Sudbury",
        "cityCode": "YSB",
        "cityName": "Sudbury",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YQY",
        "name": "Sydney / J.A. Douglas McCurdy",
        "cityCode": "YQY",
        "cityName": "Sydney",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "RAI", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "SYR",
        "name": "Syracuse Hancock",
        "cityCode": "SYR",
        "cityName": "Syracuse",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "SFL",
        "name": "São Filipe Airport",
        "cityCode": "SFL",
        "cityName": "São Filipe",
        "countryCode": "CV",
        "countryName": "Cabo Verde",
        "regionName": "África",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "FLW", "SJZ", "CVU", "SMA", "BOS", "PDL", "HOR", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "SFO",
        "name": "São Francisco",
        "cityCode": "SFO",
        "cityName": "San Francisco",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FRA", "LIS", "PDL", "FNC", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "SJZ",
        "name": "São Jorge",
        "cityCode": "SJZ",
        "cityName": "Ilha de São Jorge (Açores)",
        "countryCode": "PT",
        "countryName": "Portugal",
        "regionName": "Açores",
        "x": 0,
        "y": 0,
        "azores": true,
        "airlineOperated": true,
        "destinations": ["TER", "JAX", "YOW", "MXP", "YXE", "CLT", "YXJ", "SLC", "STT", "DFW", "YXT", "YXS", "STX", "YXX", "TFN", "TFS", "YYC", "SMA", "YYG", "PWM", "YYF", "LGA", "HOR", "YHZ", "LON", "YQB", "YYJ", "BCN", "SMF", "IAD", "SEA", "YQG", "HOU", "MAD", "FCO", "YQM", "YYT", "RSW", "YQQ", "YQR", "YYZ", "LPA", "YQU", "YQT", "ARN", "LGW", "BDA", "YQY", "YQX", "CVU", "TPA", "YAM", "YZF", "BTV", "PXO", "FLL", "HPN", "VLC", "SVO", "FLW", "ABQ", "HYA", "BUF", "PHL", "VDE", "LHR", "FUE", "SFL", "SFO", "BUR", "PHX", "RDU", "SWF", "ACE", "YSB", "MSP", "YKA", "BVC", "MSY", "LIS", "MCO", "FNC", "PIT", "CPH", "YCD", "PIX", "LAS", "LAX", "CHI", "SPC", "JFK", "OPO", "CHS", "RNO", "BWI", "YTO", "YTS", "MUC", "YDF", "YTZ", "AUS", "MDW", "DCA", "YLW", "BOS", "ROC", "AMS", "PSP", "SYR", "SID", "YUL", "OAK", "YMM", "YEG", "TCI", "ORD", "SAN", "VXE", "ORH", "DTW", "WAS", "SAV", "GRW", "SJC", "MVY", "SRQ", "YVR", "ORY", "YFC", "PDL", "NYC", "EWR", "PDX", "YWG", "AGP", "DEN", "RIC", "FRA", "FAO", "RAI", "CLE", "PVD"],
        "partnerAirport": false
    }, {
        "code": "TPA",
        "name": "Tampa",
        "cityCode": "TPA",
        "cityName": "Tampa",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "TCI",
        "name": "Tenerife (Todos os Aeroportos)",
        "cityCode": "TCI",
        "cityName": "Tenerife",
        "countryCode": "ES",
        "countryName": "Espanha",
        "regionName": "Europa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "PDL", "HOR", "FNC", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "TFN",
        "name": "Tenerife Norte",
        "cityCode": "TCI",
        "cityName": "Tenerife",
        "countryCode": "ES",
        "countryName": "Espanha",
        "regionName": "Europa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "PDL", "HOR", "FNC", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "TFS",
        "name": "Tenerife Sul",
        "cityCode": "TCI",
        "cityName": "Tenerife",
        "countryCode": "ES",
        "countryName": "Espanha",
        "regionName": "Europa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "PDL", "HOR", "FNC", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "TER",
        "name": "Terceira",
        "cityCode": "TER",
        "cityName": "Ilha Terceira (Açores)",
        "countryCode": "PT",
        "countryName": "Portugal",
        "regionName": "Açores",
        "x": 0,
        "y": 0,
        "azores": true,
        "airlineOperated": true,
        "destinations": ["JAX", "YOW", "MXP", "YXE", "CLT", "YXJ", "SLC", "STT", "DFW", "YXT", "YXS", "STX", "YXX", "TFN", "TFS", "YYC", "SMA", "LGB", "YYG", "PWM", "YYF", "LGA", "HOR", "YHZ", "LON", "YQB", "YYJ", "BCN", "SMF", "IAD", "SEA", "YQG", "HOU", "MAD", "FCO", "YQM", "YYT", "RSW", "YQQ", "YQR", "YYZ", "LPA", "YQU", "YQT", "ARN", "LGW", "BDA", "YQY", "YQX", "CVU", "TPA", "YAM", "YZF", "BTV", "PXO", "FLL", "HPN", "VLC", "SVO", "SVQ", "FLW", "ABQ", "HYA", "BUF", "PHL", "VDE", "LHR", "FUE", "SFL", "SFO", "BUR", "PHX", "RDU", "SWF", "ACE", "YSB", "MSP", "YKA", "BVC", "MSY", "LIS", "MCO", "FNC", "PIT", "CPH", "YCD", "PIX", "LAS", "LAX", "CHI", "SPC", "JFK", "OPO", "CHS", "RNO", "BWI", "YTO", "YTS", "MUC", "YDF", "YTZ", "AUS", "MDW", "DCA", "YLW", "BOS", "ROC", "AMS", "PSP", "SYR", "SID", "YUL", "OAK", "YMM", "YEG", "TCI", "ORD", "SAN", "VXE", "ORH", "DTW", "WAS", "SAV", "GRW", "SJC", "MVY", "SRQ", "YVR", "ORY", "YFC", "PDL", "NYC", "EWR", "SJZ", "PDX", "YWG", "BIO", "AGP", "DEN", "RIC", "FRA", "FAO", "RAI", "CLE", "PVD"],
        "partnerAirport": false
    }, {
        "code": "YXT",
        "name": "Terrace",
        "cityCode": "YXT",
        "cityName": "Terrace",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "RAI", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YQT",
        "name": "Thunder Bay",
        "cityCode": "YQT",
        "cityName": "Thunder Bay",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YTS",
        "name": "Timmins",
        "cityCode": "YTS",
        "cityName": "Timmins",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "YTO",
        "name": "Toronto (Todos os Aeroportos)",
        "cityCode": "YTO",
        "cityName": "Toronto",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "VXE", "CVU", "MXP", "VLC", "GRW", "OPO", "SVQ", "FLW", "ZRH", "LHR", "ORY", "PDL", "MUC", "SJZ", "SMA", "AMS", "BIO", "HOR", "AGP", "LON", "BCN", "SID", "MAD", "FCO", "FRA", "FAO", "LIS", "FNC", "CPH", "RAI", "LPA", "ARN", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "VLC",
        "name": "Valência",
        "cityCode": "VLC",
        "cityName": "Valencia",
        "countryCode": "ES",
        "countryName": "Espanha",
        "regionName": "Europa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "YUL", "SJZ", "CVU", "SMA", "BOS", "PDL", "HOR", "FNC", "YYZ", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YVR",
        "name": "Vancouver internacional",
        "cityCode": "YVR",
        "cityName": "Vancouver",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YYJ",
        "name": "Victoria",
        "cityCode": "YYJ",
        "cityName": "Victoria",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "WAS",
        "name": "Washington (Todos os Aeroportos)",
        "cityCode": "WAS",
        "cityName": "Washington",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "IAD",
        "name": "Washington Dulles",
        "cityCode": "WAS",
        "cityName": "Washington",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "PBI",
        "name": "West Palm Beach",
        "cityCode": "PBI",
        "cityName": "West Palm Beach",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "LIS", "PDL", "OPO"],
        "partnerAirport": false
    }, {
        "code": "HPN",
        "name": "Westchester",
        "cityCode": "HPN",
        "cityName": "Westchester",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "YQG",
        "name": "Windsor",
        "cityCode": "YQG",
        "cityName": "Windsor",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YWG",
        "name": "Winnipeg J. Armstrong Rich.",
        "cityCode": "YWG",
        "cityName": "Winnipeg",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "ORH",
        "name": "Worcester",
        "cityCode": "ORH",
        "cityName": "Worcester",
        "countryCode": "US",
        "countryName": "Estados Unidos",
        "regionName": "Estados Unidos",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "YZF",
        "name": "Yellowknife",
        "cityCode": "YZF",
        "cityName": "Yellowknife",
        "countryCode": "CA",
        "countryName": "Canadá",
        "regionName": "Canadá",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "RAI", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "ZRH",
        "name": "Zürich",
        "cityCode": "ZRH",
        "cityName": "Zurich",
        "countryCode": "CH",
        "countryName": "Suíça",
        "regionName": "Europa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["YUL", "BOS", "YYZ"],
        "partnerAirport": false
    }],
    en: [{
        "code": "YXX",
        "name": "Abbotsford",
        "cityCode": "YXX",
        "cityName": "Abbotsford",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "AMS",
        "name": "Amsterdam",
        "cityCode": "AMS",
        "cityName": "Amsterdam",
        "countryCode": "NL",
        "countryName": "Netherlands",
        "regionName": "Europe",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "BOS", "PDL", "HOR", "FNC", "YYZ", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "SID",
        "name": "Amílcar Cabral International",
        "cityCode": "SID",
        "cityName": "Sal",
        "countryCode": "CV",
        "countryName": "Cape Verde",
        "regionName": "Africa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "BOS", "HOR", "GRW", "OPO", "FLW", "YUL", "LIS", "PDL", "FNC", "YYZ", "PIX", "PVD"],
        "partnerAirport": false
    }, {
        "code": "ARN",
        "name": "Arlanda",
        "cityCode": "STO",
        "cityName": "Stockholm",
        "countryCode": "SE",
        "countryName": "Sweden",
        "regionName": "Europe",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "BOS", "HOR", "GRW", "FLW", "YUL", "PDL", "FNC", "YYZ", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YTZ",
        "name": "B. Bish. Toronto City Centre",
        "cityCode": "YTO",
        "cityName": "Toronto",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "AGP", "GRW", "OPO", "SVQ", "FLW", "MAD", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "BWI",
        "name": "Balt./Wash. International",
        "cityCode": "BWI",
        "cityName": "Baltimore",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "BCN",
        "name": "Barcelona",
        "cityCode": "BCN",
        "cityName": "Barcelona",
        "countryCode": "ES",
        "countryName": "Spain",
        "regionName": "Europe",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": true,
        "destinations": ["TER", "YQY", "SAN", "YQX", "LAX", "CVU", "YZF", "YXJ", "GRW", "FLW", "YXT", "YXS", "YFC", "PDL", "YDF", "SFO", "SJZ", "PDX", "SMA", "BOS", "YYF", "HOR", "PSP", "SEA", "YUL", "YQQ", "YMM", "OAK", "FNC", "YYZ", "YCD", "RAI", "YQU", "PIX", "PVD", "LAS"],
        "partnerAirport": false
    }, {
        "code": "HYA",
        "name": "Barnstable Municipal Airport",
        "cityCode": "HYA",
        "cityName": "Hyannis",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "BDA",
        "name": "Bermuda",
        "cityCode": "BDA",
        "cityName": "Bermuda",
        "countryCode": "BM",
        "countryName": "Bermuda",
        "regionName": "Europe",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "BIO",
        "name": "Bilbao",
        "cityCode": "BIO",
        "cityName": "Bilbao",
        "countryCode": "ES",
        "countryName": "Spain",
        "regionName": "Europe",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "YUL", "SJZ", "CVU", "SMA", "BOS", "PDL", "HOR", "FNC", "YYZ", "GRW"],
        "partnerAirport": false
    }, {
        "code": "BUR",
        "name": "Bob Hope",
        "cityCode": "BUR",
        "cityName": "Burbank",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "BOS",
        "name": "Boston Logan",
        "cityCode": "BOS",
        "cityName": "Boston",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": true,
        "destinations": ["TER", "VXE", "CVU", "MXP", "SNE", "VLC", "GRW", "OPO", "FLW", "ZRH", "LHR", "ORY", "SFL", "PDL", "MUC", "SJZ", "SMA", "AMS", "BIO", "HOR", "LON", "BCN", "BVC", "SID", "MAD", "FCO", "FRA", "FAO", "LIS", "FNC", "CPH", "RAI", "LPA", "ARN", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "SRQ",
        "name": "Bradenton",
        "cityCode": "SRQ",
        "cityName": "Sarasota/ Bradenton",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "BUF",
        "name": "Buffalo Niagara",
        "cityCode": "BUF",
        "cityName": "Buffalo",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "YYC",
        "name": "Calgary",
        "cityCode": "YYC",
        "cityName": "Calgary",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "VXE",
        "name": "Cesária Évora Airport",
        "cityCode": "VXE",
        "cityName": "Mindelo",
        "countryCode": "CV",
        "countryName": "Cape Verde",
        "regionName": "Africa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "BOS", "HOR", "GRW", "OPO", "FLW", "YUL", "LIS", "PDL", "FNC", "YYZ", "PIX", "PVD"],
        "partnerAirport": false
    }, {
        "code": "CHS",
        "name": "Charleston International Airport",
        "cityCode": "CHS",
        "cityName": "Charleston",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "CLT",
        "name": "Charlotte Douglas",
        "cityCode": "CLT",
        "cityName": "Charlotte",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "YYG",
        "name": "Charlottetown",
        "cityCode": "YYG",
        "cityName": "Charlottetown",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "CHI",
        "name": "Chicago (All Airports)",
        "cityCode": "CHI",
        "cityName": "Chicago",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FRA", "FAO", "LIS", "PDL", "FNC", "MUC", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "MDW",
        "name": "Chicago Midway",
        "cityCode": "CHI",
        "cityName": "Chicago",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FRA", "FAO", "LIS", "PDL", "FNC", "MUC", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "ORD",
        "name": "Chicago O\u0027Hare International Airport",
        "cityCode": "CHI",
        "cityName": "Chicago",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "CLE",
        "name": "Cleveland Hopkins",
        "cityCode": "CLE",
        "cityName": "Cleveland",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "YQQ",
        "name": "Comox",
        "cityCode": "YQQ",
        "cityName": "Comox",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "RAI", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "CPH",
        "name": "Copenhagen Kastrup",
        "cityCode": "CPH",
        "cityName": "Copenhagen",
        "countryCode": "DK",
        "countryName": "Denmark",
        "regionName": "Europe",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "YUL", "SJZ", "CVU", "SMA", "BOS", "PDL", "HOR", "YYZ", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "CVU",
        "name": "Corvo",
        "cityCode": "CVU",
        "cityName": "Corvo Island (Azores)",
        "countryCode": "PT",
        "countryName": "Portugal",
        "regionName": "Azores",
        "x": 0,
        "y": 0,
        "azores": true,
        "airlineOperated": true,
        "destinations": ["TER", "JAX", "YOW", "MXP", "YXE", "CLT", "YXJ", "SLC", "STT", "DFW", "YXT", "YXS", "STX", "YXX", "TFN", "TFS", "YYC", "SMA", "YYG", "PWM", "YYF", "LGA", "HOR", "YHZ", "LON", "YQB", "YYJ", "BCN", "SMF", "IAD", "SEA", "YQG", "HOU", "MAD", "FCO", "YQM", "YYT", "RSW", "YQQ", "YQR", "YYZ", "LPA", "YQU", "YQT", "ARN", "LGW", "BDA", "YQY", "YQX", "TPA", "YAM", "YZF", "BTV", "PXO", "FLL", "HPN", "VLC", "SVO", "SVQ", "FLW", "ABQ", "HYA", "BUF", "PHL", "VDE", "LHR", "FUE", "SFL", "SFO", "BUR", "PHX", "RDU", "SWF", "ACE", "YSB", "MSP", "YKA", "BVC", "MSY", "LIS", "MCO", "FNC", "PIT", "CPH", "YCD", "PIX", "LAS", "LAX", "CHI", "SPC", "JFK", "OPO", "CHS", "RNO", "BWI", "YTO", "YTS", "MUC", "YDF", "YTZ", "AUS", "MDW", "DCA", "YLW", "BOS", "ROC", "AMS", "PSP", "SYR", "SID", "YUL", "OAK", "YMM", "YEG", "TCI", "ORD", "SAN", "VXE", "ORH", "DTW", "WAS", "SAV", "GRW", "SJC", "MVY", "SRQ", "YVR", "ORY", "YFC", "PDL", "NYC", "EWR", "SJZ", "PDX", "YWG", "BIO", "AGP", "DEN", "RIC", "FRA", "FAO", "RAI", "CLE", "PVD"],
        "partnerAirport": false
    }, {
        "code": "STT",
        "name": "Cyril E. King",
        "cityCode": "STT",
        "cityName": "St. Thomas",
        "countryCode": "VI",
        "countryName": "U.S. Virgin Islands",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "DFW",
        "name": "Dallas Fort Worth",
        "cityCode": "DFW",
        "cityName": "Dallas/Ft. Worth",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "YDF",
        "name": "Deer Lake",
        "cityCode": "YDF",
        "cityName": "Deer Lake",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "RAI", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "DEN",
        "name": "Denver International",
        "cityCode": "DEN",
        "cityName": "Denver",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "DTW",
        "name": "Detroit Wayne County",
        "cityCode": "DTT",
        "cityName": "Detroit",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YEG",
        "name": "Edmonton International",
        "cityCode": "YEA",
        "cityName": "Edmonton",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "FAO",
        "name": "Faro",
        "cityCode": "FAO",
        "cityName": "Faro",
        "countryCode": "PT",
        "countryName": "Portugal",
        "regionName": "Portugal Mainland",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "JAX", "YOW", "CHI", "YXE", "CLT", "YXJ", "SLC", "JFK", "CHS", "RNO", "STT", "DFW", "YXT", "YXS", "YTO", "STX", "YXX", "YDF", "YTZ", "AUS", "MDW", "YYC", "YLW", "SMA", "BOS", "PWM", "ROC", "YYF", "HOR", "YHZ", "YQB", "YYJ", "SMF", "SYR", "SEA", "HOU", "YUL", "YQM", "YYT", "RSW", "OAK", "YQQ", "YMM", "YEG", "YQR", "YYZ", "YQU", "YQT", "ORD", "YQY", "SAN", "YQX", "CVU", "ORH", "TPA", "YAM", "YZF", "BTV", "PXO", "DTW", "FLL", "HPN", "SAV", "GRW", "SJC", "FLW", "HYA", "MVY", "BUF", "SRQ", "YVR", "PHL", "YFC", "PDL", "NYC", "BUR", "EWR", "PHX", "SJZ", "RDU", "SWF", "PDX", "YWG", "YSB", "DEN", "RIC", "YKA", "MSY", "MCO", "FNC", "PIT", "YCD", "CLE", "PIX", "LAS"],
        "partnerAirport": false
    }, {
        "code": "FLW",
        "name": "Flores",
        "cityCode": "FLW",
        "cityName": "Flores Island (Azores)",
        "countryCode": "PT",
        "countryName": "Portugal",
        "regionName": "Azores",
        "x": 0,
        "y": 0,
        "azores": true,
        "airlineOperated": true,
        "destinations": ["TER", "JAX", "YOW", "MXP", "YXE", "CLT", "YXJ", "SLC", "STT", "DFW", "YXT", "YXS", "STX", "YXX", "TFN", "TFS", "YYC", "SMA", "YYG", "PWM", "YYF", "LGA", "HOR", "YHZ", "LON", "YQB", "YYJ", "BCN", "SMF", "IAD", "SEA", "YQG", "HOU", "MAD", "FCO", "YQM", "YYT", "RSW", "YQQ", "YQR", "YYZ", "LPA", "YQU", "YQT", "ARN", "LGW", "BDA", "YQY", "YQX", "CVU", "TPA", "YAM", "YZF", "BTV", "PXO", "FLL", "HPN", "VLC", "SVO", "SVQ", "ABQ", "HYA", "BUF", "PHL", "VDE", "LHR", "FUE", "SFL", "SFO", "BUR", "PHX", "RDU", "SWF", "ACE", "YSB", "MSP", "YKA", "BVC", "MSY", "LIS", "MCO", "FNC", "PIT", "CPH", "YCD", "PIX", "LAS", "LAX", "CHI", "SPC", "JFK", "OPO", "CHS", "RNO", "BWI", "YTO", "YTS", "MUC", "YDF", "YTZ", "AUS", "MDW", "DCA", "YLW", "BOS", "ROC", "AMS", "PSP", "SYR", "SID", "YUL", "OAK", "YMM", "YEG", "TCI", "ORD", "SAN", "VXE", "ORH", "DTW", "WAS", "SAV", "GRW", "SJC", "MVY", "SRQ", "YVR", "ORY", "YFC", "PDL", "NYC", "EWR", "SJZ", "PDX", "YWG", "BIO", "AGP", "DEN", "RIC", "FRA", "FAO", "RAI", "CLE", "PVD"],
        "partnerAirport": false
    }, {
        "code": "FLL",
        "name": "Fort Lauderdale",
        "cityCode": "FLL",
        "cityName": "Fort Lauderdale",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YMM",
        "name": "Fort McMurray",
        "cityCode": "YMM",
        "cityName": "Fort McMurray",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "RAI", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YXJ",
        "name": "Fort St John",
        "cityCode": "YXJ",
        "cityName": "Fort St. John",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "RAI", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "FRA",
        "name": "Frankfurt",
        "cityCode": "FRA",
        "cityName": "Frankfurt",
        "countryCode": "DE",
        "countryName": "Germany",
        "regionName": "Europe",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": true,
        "destinations": ["TER", "MDW", "SAN", "SJZ", "LAX", "CVU", "PDX", "SMA", "BOS", "HOR", "PSP", "BCN", "GRW", "SEA", "FLW", "YUL", "OAK", "PDL", "FNC", "YYZ", "SFO", "PIX", "LAS", "PVD"],
        "partnerAirport": false
    }, {
        "code": "MUC",
        "name": "Franz Josef Strauss",
        "cityCode": "MUC",
        "cityName": "Munich",
        "countryCode": "DE",
        "countryName": "Germany",
        "regionName": "Europe",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "MDW", "SJZ", "CVU", "SMA", "BOS", "HOR", "GRW", "OPO", "FLW", "YUL", "PDL", "FNC", "YYZ", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YFC",
        "name": "Fredericton",
        "cityCode": "YFC",
        "cityName": "Fredericton",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "RAI", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "FUE",
        "name": "Fuerteventura",
        "cityCode": "FUE",
        "cityName": "Puerto del Rosario",
        "countryCode": "ES",
        "countryName": "Spain",
        "regionName": "Europe",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "FLW", "SJZ", "CVU", "SMA", "PDL", "FNC", "HOR", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "FNC",
        "name": "Funchal",
        "cityCode": "FNC",
        "cityName": "Funchal (Madeira)",
        "countryCode": "PT",
        "countryName": "Portugal",
        "regionName": "Madeira",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": true,
        "destinations": ["TER", "YOW", "LAX", "YXE", "SPC", "YXJ", "OPO", "YXT", "YXS", "YTO", "YXX", "YTS", "MUC", "YDF", "TFN", "YTZ", "TFS", "MDW", "YYC", "YLW", "SMA", "BOS", "AMS", "YYF", "LGA", "HOR", "YHZ", "LON", "YQB", "YYJ", "BGO", "BCN", "PSP", "SEA", "YQG", "MAD", "YUL", "YQM", "YYT", "YQQ", "YMM", "OAK", "YEG", "YQR", "YYZ", "TCI", "LPA", "YQU", "YQT", "ARN", "LGW", "YQY", "SAN", "YQX", "VXE", "CVU", "YAM", "YZF", "FLL", "VLC", "GRW", "SVQ", "FLW", "YVR", "VDE", "FUE", "LHR", "YFC", "PDL", "NYC", "SFO", "EWR", "SJZ", "ACE", "PDX", "YWG", "BIO", "OSL", "YSB", "AGP", "MSP", "YKA", "FRA", "FAO", "LIS", "CPH", "RAI", "YCD", "PIX", "LAS", "PVD"],
        "partnerAirport": false
    }, {
        "code": "YQX",
        "name": "Gander International",
        "cityCode": "YQX",
        "cityName": "Gander",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "RAI", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "GRW",
        "name": "Graciosa",
        "cityCode": "GRW",
        "cityName": "Graciosa Island (Azores)",
        "countryCode": "PT",
        "countryName": "Portugal",
        "regionName": "Azores",
        "x": 0,
        "y": 0,
        "azores": true,
        "airlineOperated": true,
        "destinations": ["TER", "JAX", "YOW", "MXP", "YXE", "CLT", "YXJ", "SLC", "STT", "DFW", "YXT", "YXS", "STX", "YXX", "TFN", "TFS", "YYC", "SMA", "YYG", "PWM", "YYF", "LGA", "HOR", "YHZ", "LON", "YQB", "YYJ", "BCN", "SMF", "IAD", "SEA", "YQG", "HOU", "MAD", "FCO", "YQM", "YYT", "RSW", "YQQ", "YQR", "YYZ", "LPA", "YQU", "YQT", "ARN", "LGW", "BDA", "YQY", "YQX", "CVU", "TPA", "YAM", "YZF", "BTV", "PXO", "FLL", "HPN", "VLC", "SVO", "SVQ", "FLW", "ABQ", "HYA", "BUF", "PHL", "VDE", "LHR", "FUE", "SFL", "SFO", "BUR", "PHX", "RDU", "SWF", "ACE", "YSB", "MSP", "YKA", "BVC", "MSY", "LIS", "MCO", "FNC", "PIT", "CPH", "YCD", "PIX", "LAS", "LAX", "CHI", "SPC", "JFK", "OPO", "CHS", "RNO", "BWI", "YTO", "YTS", "MUC", "YDF", "YTZ", "AUS", "MDW", "DCA", "YLW", "BOS", "AMS", "PSP", "SYR", "SID", "YUL", "OAK", "YMM", "YEG", "TCI", "ORD", "SAN", "VXE", "ORH", "DTW", "WAS", "SAV", "SJC", "MVY", "SRQ", "YVR", "ORY", "YFC", "PDL", "NYC", "EWR", "SJZ", "PDX", "YWG", "BIO", "AGP", "DEN", "RIC", "FRA", "FAO", "RAI", "CLE", "PVD"],
        "partnerAirport": false
    }, {
        "code": "YQU",
        "name": "Grande Prairie",
        "cityCode": "YQU",
        "cityName": "Grande Prairie",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "RAI", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YQM",
        "name": "Greater Moncton",
        "cityCode": "YQM",
        "cityName": "Moncton",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "ROC",
        "name": "Greater Rochester",
        "cityCode": "ROC",
        "cityName": "Rochester",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "YHZ",
        "name": "Halifax/Stanfield",
        "cityCode": "YHZ",
        "cityName": "Halifax",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "OTP",
        "name": "Henri Coandă",
        "cityCode": "BUH",
        "cityName": "Bucharest",
        "countryCode": "RO",
        "countryName": "Romania",
        "regionName": "Europe",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["PDL"],
        "partnerAirport": false
    }, {
        "code": "STX",
        "name": "Henry E Rohlsen",
        "cityCode": "STX",
        "cityName": "Saint Croix",
        "countryCode": "VI",
        "countryName": "U.S. Virgin Islands",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "VDE",
        "name": "Hierro",
        "cityCode": "VDE",
        "cityName": "Valverde",
        "countryCode": "ES",
        "countryName": "Spain",
        "regionName": "Europe",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "FLW", "SJZ", "CVU", "SMA", "PDL", "FNC", "HOR", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "HOR",
        "name": "Horta",
        "cityCode": "HOR",
        "cityName": "Faial Island (Azores)",
        "countryCode": "PT",
        "countryName": "Portugal",
        "regionName": "Azores",
        "x": 0,
        "y": 0,
        "azores": true,
        "airlineOperated": true,
        "destinations": ["TER", "JAX", "YOW", "MXP", "YXE", "CLT", "YXJ", "SLC", "STT", "DFW", "YXT", "YXS", "STX", "YXX", "TFN", "TFS", "YYC", "SMA", "YYG", "PWM", "YYF", "LGA", "YHZ", "LON", "YQB", "YYJ", "BCN", "SMF", "IAD", "SEA", "YQG", "HOU", "MAD", "FCO", "YQM", "YYT", "RSW", "YQQ", "YQR", "YYZ", "LPA", "YQU", "YQT", "ARN", "LGW", "BDA", "YQY", "YQX", "CVU", "TPA", "YAM", "YZF", "BTV", "PXO", "HPN", "VLC", "SVO", "SVQ", "FLW", "ABQ", "HYA", "BUF", "PHL", "VDE", "LHR", "FUE", "SFL", "SFO", "BUR", "PHX", "RDU", "SWF", "ACE", "YSB", "MSP", "YKA", "BVC", "MSY", "LIS", "MCO", "FNC", "PIT", "CPH", "YCD", "PIX", "LAS", "LAX", "CHI", "SPC", "JFK", "OPO", "CHS", "RNO", "BWI", "YTO", "YTS", "MUC", "YDF", "YTZ", "AUS", "MDW", "DCA", "YLW", "BOS", "ROC", "AMS", "PSP", "SYR", "SID", "YUL", "OAK", "YMM", "YEG", "TCI", "ORD", "SAN", "VXE", "ORH", "DTW", "WAS", "SAV", "GRW", "SJC", "MVY", "SRQ", "YVR", "ORY", "YFC", "PDL", "NYC", "EWR", "SJZ", "PDX", "YWG", "BIO", "AGP", "DEN", "RIC", "FRA", "FAO", "RAI", "CLE", "PVD"],
        "partnerAirport": false
    }, {
        "code": "JAX",
        "name": "Jacksonville",
        "cityCode": "JAX",
        "cityName": "Jacksonville",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "JFK",
        "name": "John F Kennedy",
        "cityCode": "NYC",
        "cityName": "New York",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "YKA",
        "name": "Kamloops",
        "cityCode": "YKA",
        "cityName": "Kamloops",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YLW",
        "name": "Kelowna",
        "cityCode": "YLW",
        "cityName": "Kelowna",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "MSY",
        "name": "L. Armstrong New Orleans",
        "cityCode": "MSY",
        "cityName": "New Orleans",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "LGA",
        "name": "La Guardia",
        "cityCode": "NYC",
        "cityName": "New York",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "SPC",
        "name": "La Palma",
        "cityCode": "SPC",
        "cityName": "Santa Cruz De La Palma",
        "countryCode": "ES",
        "countryName": "Spain",
        "regionName": "Europe",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "PDL", "FNC", "HOR", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "ACE",
        "name": "Lanzarote",
        "cityCode": "ACE",
        "cityName": "Lanzarote",
        "countryCode": "ES",
        "countryName": "Spain",
        "regionName": "Europe",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "PDL", "HOR", "FNC", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "LPA",
        "name": "Las Palmas",
        "cityCode": "LPA",
        "cityName": "Gran Canaria",
        "countryCode": "ES",
        "countryName": "Spain",
        "regionName": "Europe",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": true,
        "destinations": ["TER", "YOW", "LAX", "YXE", "YXJ", "YXT", "YXS", "YTO", "YXX", "YDF", "YTZ", "MDW", "YYC", "YLW", "SMA", "BOS", "YYF", "LGA", "HOR", "YHZ", "YQB", "YYJ", "PSP", "SEA", "YQG", "YUL", "YQM", "YQQ", "YMM", "OAK", "YEG", "YYZ", "YQU", "YQT", "YQY", "SAN", "YQX", "CVU", "YZF", "PXO", "FLL", "GRW", "FLW", "YVR", "YFC", "PDL", "NYC", "SFO", "EWR", "SJZ", "PDX", "YWG", "MSP", "YKA", "LIS", "FNC", "YCD", "RAI", "PIX", "LAS", "PVD"],
        "partnerAirport": false
    }, {
        "code": "FCO",
        "name": "Leonardo Da Vinci",
        "cityCode": "ROM",
        "cityName": "Rome",
        "countryCode": "IT",
        "countryName": "Italy",
        "regionName": "Europe",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "FLW", "YUL", "SJZ", "CVU", "SMA", "BOS", "PDL", "HOR", "YYZ", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YYZ",
        "name": "Lester B. Pearson",
        "cityCode": "YTO",
        "cityName": "Toronto",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": true,
        "destinations": ["TER", "VXE", "CVU", "MXP", "VLC", "GRW", "OPO", "SVQ", "FLW", "ZRH", "LHR", "ORY", "PDL", "MUC", "SJZ", "SMA", "AMS", "BIO", "HOR", "AGP", "LON", "BCN", "SID", "MAD", "FCO", "FRA", "FAO", "LIS", "FNC", "CPH", "RAI", "LPA", "ARN", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "LIS",
        "name": "Lisbon",
        "cityCode": "LIS",
        "cityName": "Lisbon",
        "countryCode": "PT",
        "countryName": "Portugal",
        "regionName": "Portugal Mainland",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": true,
        "destinations": ["TER", "JAX", "YOW", "YXE", "CLT", "YXJ", "SLC", "STT", "DFW", "YXT", "YXS", "STX", "YXX", "YYC", "SMA", "LGB", "YYG", "PWM", "YYF", "LGA", "HOR", "YHZ", "YQB", "YYJ", "SMF", "IAD", "SEA", "YQG", "HOU", "YQM", "YYT", "RSW", "YQQ", "YQR", "YYZ", "LPA", "YQU", "YQT", "BDA", "YQY", "YQX", "CVU", "TPA", "YAM", "YZF", "BTV", "PXO", "FLL", "HPN", "FLW", "ABQ", "HYA", "BUF", "PHL", "SFO", "BUR", "PHX", "RDU", "SWF", "YSB", "MSP", "YKA", "MSY", "MCO", "FNC", "PIT", "YCD", "PIX", "LAS", "LAX", "CHI", "JFK", "RNO", "BWI", "YTO", "PBI", "YTS", "YDF", "YTZ", "MDW", "DCA", "YLW", "BOS", "ROC", "PSP", "SYR", "YUL", "OAK", "YMM", "YEG", "ORD", "SAN", "VXE", "ORH", "DTW", "WAS", "SAV", "GRW", "SJC", "MVY", "SRQ", "YVR", "YFC", "PDL", "NYC", "EWR", "SJZ", "PDX", "YWG", "DEN", "RIC", "RAI", "CLE", "PVD"],
        "partnerAirport": false
    }, {
        "code": "LON",
        "name": "London (All Airports)",
        "cityCode": "LON",
        "cityName": "London",
        "countryCode": "GB",
        "countryName": "United Kingdom",
        "regionName": "Europe",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "YQY", "SAN", "YQX", "LAX", "CVU", "YZF", "YXJ", "GRW", "FLW", "YXT", "YXS", "YFC", "PDL", "YDF", "SFO", "MDW", "SJZ", "PDX", "SMA", "BOS", "YYF", "HOR", "PSP", "SEA", "YUL", "YQQ", "YMM", "OAK", "FNC", "YYZ", "YCD", "RAI", "YQU", "PIX", "LAS", "PVD"],
        "partnerAirport": false
    }, {
        "code": "LGW",
        "name": "London Gatwick",
        "cityCode": "LON",
        "cityName": "London",
        "countryCode": "GB",
        "countryName": "United Kingdom",
        "regionName": "Europe",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": true,
        "destinations": ["TER", "YQY", "SAN", "YQX", "LAX", "CVU", "YZF", "YXJ", "GRW", "FLW", "YXT", "YXS", "YFC", "PDL", "YDF", "SFO", "MDW", "SJZ", "PDX", "SMA", "BOS", "YYF", "HOR", "PSP", "SEA", "YUL", "YQQ", "YMM", "OAK", "FNC", "YYZ", "YCD", "RAI", "YQU", "PIX", "LAS", "PVD"],
        "partnerAirport": false
    }, {
        "code": "LHR",
        "name": "London Heathrow",
        "cityCode": "LON",
        "cityName": "London",
        "countryCode": "GB",
        "countryName": "United Kingdom",
        "regionName": "Europe",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "BOS", "PDL", "HOR", "FNC", "YYZ", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "LGB",
        "name": "Long Beach /Daugherty Field",
        "cityCode": "LGB",
        "cityName": "Long Beach",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "LIS", "PDL", "OPO"],
        "partnerAirport": false
    }, {
        "code": "LAX",
        "name": "Los Angeles",
        "cityCode": "LAX",
        "cityName": "Los Angeles",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FRA", "LIS", "PDL", "FNC", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "MAD",
        "name": "Madrid Barajas",
        "cityCode": "MAD",
        "cityName": "Madrid",
        "countryCode": "ES",
        "countryName": "Spain",
        "regionName": "Europe",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "BOS", "HOR", "GRW", "FLW", "YUL", "YTO", "PDL", "FNC", "YYZ", "PIX", "YTZ"],
        "partnerAirport": false
    }, {
        "code": "MXP",
        "name": "Malpensa",
        "cityCode": "MIL",
        "cityName": "Milan",
        "countryCode": "IT",
        "countryName": "Italy",
        "regionName": "Europe",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "FLW", "YUL", "SJZ", "CVU", "SMA", "BOS", "PDL", "HOR", "YYZ", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "MVY",
        "name": "Martha\u0027s Vineyard",
        "cityCode": "MVY",
        "cityName": "Marthas Vineyard",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "LAS",
        "name": "McCarran International",
        "cityCode": "LAS",
        "cityName": "Las Vegas",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FRA", "FAO", "LIS", "PDL", "FNC", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "OAK",
        "name": "Metropolitan Oakland",
        "cityCode": "OAK",
        "cityName": "Oakland",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": true,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FRA", "FAO", "LIS", "PDL", "FNC", "RAI", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "MSP",
        "name": "Minneapolis-St Paul International/Wold-Chamberlain",
        "cityCode": "MSP",
        "cityName": "Minneapolis",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YUL",
        "name": "Montreal-Pierre E.Trud.",
        "cityCode": "YMQ",
        "cityName": "Montreal",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": true,
        "destinations": ["TER", "VXE", "CVU", "MXP", "VLC", "GRW", "OPO", "SVQ", "FLW", "ZRH", "ORY", "PDL", "MUC", "SJZ", "SMA", "BIO", "HOR", "AGP", "BCN", "SID", "MAD", "FCO", "FRA", "FAO", "LIS", "FNC", "CPH", "RAI", "LPA", "LGW", "ARN", "PIX"],
        "partnerAirport": false
    }, {
        "code": "AGP",
        "name": "Málaga",
        "cityCode": "AGP",
        "cityName": "Malaga",
        "countryCode": "ES",
        "countryName": "Spain",
        "regionName": "Europe",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "FLW", "YUL", "YTO", "PDL", "FNC", "YYZ", "PIX", "YTZ"],
        "partnerAirport": false
    }, {
        "code": "YCD",
        "name": "Nanaimo",
        "cityCode": "YCD",
        "cityName": "Nanaimo",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "RAI", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "NYC",
        "name": "New York (All Airports)",
        "cityCode": "NYC",
        "cityName": "New York",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "EWR",
        "name": "Newark",
        "cityCode": "NYC",
        "cityName": "New York",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "SJC",
        "name": "Norman Y. Mineta San Jose",
        "cityCode": "SJC",
        "cityName": "San Jose",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "MCO",
        "name": "Orlando International",
        "cityCode": "ORL",
        "cityName": "Orlando",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "OSL",
        "name": "Oslo Gardermoen",
        "cityCode": "OSL",
        "cityName": "Oslo",
        "countryCode": "NO",
        "countryName": "Norway",
        "regionName": "Europe",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["PDL", "FNC"],
        "partnerAirport": false
    }, {
        "code": "YOW",
        "name": "Ottawa Macdonald-Cartier",
        "cityCode": "YOW",
        "cityName": "Ottawa",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "PSP",
        "name": "Palm Springs",
        "cityCode": "PSP",
        "cityName": "Palm Springs",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FRA", "LIS", "PDL", "FNC", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "ORY",
        "name": "Paris-Orly",
        "cityCode": "PAR",
        "cityName": "Paris",
        "countryCode": "FR",
        "countryName": "France",
        "regionName": "Europe",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "YUL", "SJZ", "CVU", "SMA", "BOS", "PDL", "HOR", "YYZ", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YYF",
        "name": "Penticton",
        "cityCode": "YYF",
        "cityName": "Penticton",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "RAI", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "PHL",
        "name": "Philadelphia",
        "cityCode": "PHL",
        "cityName": "Philadelphia",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "PHX",
        "name": "Phoenix Sky Harbor",
        "cityCode": "PHX",
        "cityName": "Phoenix",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "PIX",
        "name": "Pico",
        "cityCode": "PIX",
        "cityName": "Pico Island (Azores)",
        "countryCode": "PT",
        "countryName": "Portugal",
        "regionName": "Azores",
        "x": 0,
        "y": 0,
        "azores": true,
        "airlineOperated": true,
        "destinations": ["TER", "JAX", "YOW", "MXP", "YXE", "CLT", "YXJ", "SLC", "STT", "DFW", "YXT", "YXS", "STX", "YXX", "TFN", "TFS", "YYC", "SMA", "YYG", "PWM", "YYF", "LGA", "HOR", "YHZ", "LON", "YQB", "YYJ", "BCN", "SMF", "IAD", "SEA", "YQG", "HOU", "MAD", "FCO", "YQM", "YYT", "RSW", "YQQ", "YQR", "YYZ", "LPA", "YQU", "YQT", "ARN", "LGW", "BDA", "YQY", "YQX", "CVU", "TPA", "YAM", "YZF", "BTV", "PXO", "FLL", "HPN", "VLC", "SVO", "SVQ", "FLW", "ABQ", "HYA", "BUF", "PHL", "VDE", "LHR", "FUE", "SFL", "SFO", "BUR", "PHX", "RDU", "SWF", "ACE", "YSB", "MSP", "YKA", "BVC", "MSY", "LIS", "FNC", "PIT", "CPH", "YCD", "LAS", "LAX", "CHI", "SPC", "JFK", "OPO", "CHS", "RNO", "BWI", "YTO", "YTS", "MUC", "YDF", "YTZ", "AUS", "MDW", "DCA", "YLW", "BOS", "ROC", "AMS", "PSP", "SYR", "SID", "YUL", "OAK", "YMM", "YEG", "TCI", "ORD", "SAN", "VXE", "ORH", "DTW", "WAS", "SAV", "GRW", "SJC", "MVY", "SRQ", "YVR", "ORY", "YFC", "PDL", "NYC", "EWR", "SJZ", "PDX", "YWG", "BIO", "AGP", "DEN", "RIC", "FRA", "FAO", "RAI", "CLE", "PVD"],
        "partnerAirport": false
    }, {
        "code": "PIT",
        "name": "Pittsburgh International",
        "cityCode": "PIT",
        "cityName": "Pittsburgh",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "PDL",
        "name": "Ponta Delgada",
        "cityCode": "PDL",
        "cityName": "São Miguel Island (Azores)",
        "countryCode": "PT",
        "countryName": "Portugal",
        "regionName": "Azores",
        "x": 0,
        "y": 0,
        "azores": true,
        "airlineOperated": true,
        "destinations": ["TER", "JAX", "YOW", "MXP", "YXE", "CLT", "OTP", "YXJ", "SLC", "STT", "DFW", "YXT", "YXS", "STX", "YXX", "TFN", "TFS", "YYC", "SMA", "LGB", "YYG", "PWM", "YYF", "LGA", "HOR", "YHZ", "LON", "YQB", "YYJ", "BCN", "SMF", "IAD", "SEA", "YQG", "HOU", "MAD", "FCO", "YQM", "YYT", "RSW", "YQQ", "YQR", "YYZ", "LPA", "YQU", "YQT", "ARN", "LGW", "BDA", "YQY", "YQX", "CVU", "TPA", "YAM", "YZF", "BTV", "PXO", "FLL", "HPN", "VLC", "SVO", "SVQ", "FLW", "ABQ", "HYA", "BUF", "PHL", "VDE", "LHR", "FUE", "SFL", "SFO", "BUR", "PHX", "RDU", "SWF", "ACE", "YSB", "MSP", "YKA", "BVC", "MSY", "LIS", "MCO", "FNC", "PIT", "CPH", "YCD", "PIX", "LAX", "CHI", "SPC", "JFK", "OPO", "CHS", "RNO", "BWI", "YTO", "PBI", "YTS", "MUC", "YDF", "YTZ", "AUS", "MDW", "DCA", "YLW", "BOS", "ROC", "AMS", "PSP", "SYR", "SID", "YUL", "OAK", "YMM", "YEG", "TCI", "ORD", "SAN", "VXE", "ORH", "DTW", "WAS", "SAV", "GRW", "SJC", "MVY", "SRQ", "YVR", "ORY", "YFC", "NYC", "EWR", "SJZ", "PDX", "YWG", "BIO", "OSL", "AGP", "DEN", "RIC", "FRA", "FAO", "RAI", "CLE", "PVD"],
        "partnerAirport": false
    }, {
        "code": "PDX",
        "name": "Portland International",
        "cityCode": "PDX",
        "cityName": "Portland",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FRA", "FAO", "LIS", "PDL", "FNC", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "PWM",
        "name": "Portland International Jetport",
        "cityCode": "PWM",
        "cityName": "Portland",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "OPO",
        "name": "Porto",
        "cityCode": "OPO",
        "cityName": "Porto",
        "countryCode": "PT",
        "countryName": "Portugal",
        "regionName": "Portugal Mainland",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": true,
        "destinations": ["TER", "JAX", "YOW", "YXE", "CLT", "YXJ", "SLC", "STT", "DFW", "YXT", "YXS", "STX", "YXX", "YYC", "SMA", "LGB", "YYG", "PWM", "YYF", "LGA", "HOR", "YHZ", "YQB", "YYJ", "SMF", "IAD", "SEA", "YQG", "HOU", "YQM", "YYT", "RSW", "YQQ", "YQR", "YYZ", "YQU", "YQT", "BDA", "YQY", "YQX", "CVU", "TPA", "YAM", "YZF", "BTV", "PXO", "FLL", "HPN", "SVO", "FLW", "ABQ", "HYA", "BUF", "PHL", "SFO", "BUR", "PHX", "RDU", "SWF", "YSB", "MSP", "YKA", "MSY", "MCO", "FNC", "PIT", "YCD", "PIX", "LAS", "LAX", "CHI", "JFK", "CHS", "RNO", "BWI", "YTO", "PBI", "YTS", "MUC", "YDF", "YTZ", "MDW", "DCA", "YLW", "BOS", "ROC", "PSP", "SYR", "YUL", "OAK", "YMM", "YEG", "ORD", "SAN", "VXE", "ORH", "DTW", "WAS", "SAV", "GRW", "SJC", "MVY", "SRQ", "YVR", "YFC", "PDL", "NYC", "EWR", "SJZ", "PDX", "YWG", "DEN", "RIC", "RAI", "CLE", "PVD"],
        "partnerAirport": false
    }, {
        "code": "PXO",
        "name": "Porto Santo",
        "cityCode": "PXO",
        "cityName": "Porto Santo (Madeira)",
        "countryCode": "PT",
        "countryName": "Portugal",
        "regionName": "Madeira",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "RAI",
        "name": "Praia International",
        "cityCode": "RAI",
        "cityName": "Praia",
        "countryCode": "CV",
        "countryName": "Cape Verde",
        "regionName": "Africa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": true,
        "destinations": ["TER", "YQY", "YQX", "CVU", "YZF", "YXJ", "GRW", "OPO", "FLW", "YXT", "YXS", "YFC", "PDL", "YDF", "SJZ", "SMA", "BOS", "YYF", "HOR", "BCN", "YUL", "FRA", "LIS", "YQQ", "YMM", "OAK", "FNC", "YYZ", "YCD", "YQU", "LPA", "LGW", "PIX", "PVD"],
        "partnerAirport": false
    }, {
        "code": "SNE",
        "name": "Preguiça",
        "cityCode": "SNE",
        "cityName": "Sao Nicolau",
        "countryCode": "CV",
        "countryName": "Cape Verde",
        "regionName": "Africa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["BOS"],
        "partnerAirport": false
    }, {
        "code": "YXS",
        "name": "Prince George",
        "cityCode": "YXS",
        "cityName": "Prince George",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "RAI", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "PVD",
        "name": "Providence-T. F. Green",
        "cityCode": "PVD",
        "cityName": "Providence",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": true,
        "destinations": ["TER", "SJZ", "VXE", "CVU", "SMA", "HOR", "BCN", "GRW", "SID", "OPO", "FLW", "FRA", "LIS", "PDL", "FNC", "RAI", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YQB",
        "name": "Quebec Jean Lesage",
        "cityCode": "YQB",
        "cityName": "Quebec",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "BVC",
        "name": "Rabil",
        "cityCode": "BVC",
        "cityName": "Boa Vista",
        "countryCode": "CV",
        "countryName": "Cape Verde",
        "regionName": "Africa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "FLW", "SJZ", "CVU", "SMA", "BOS", "PDL", "HOR", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "RDU",
        "name": "Raleigh Durham",
        "cityCode": "RDU",
        "cityName": "Raleigh/Durham",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "YQR",
        "name": "Regina International",
        "cityCode": "YQR",
        "cityName": "Regina",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "RNO",
        "name": "Reno-Tahoe",
        "cityCode": "RNO",
        "cityName": "Reno",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "RIC",
        "name": "Richmond International",
        "cityCode": "RIC",
        "cityName": "Richmond",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "DCA",
        "name": "Ronald Reagan Washington",
        "cityCode": "WAS",
        "cityName": "Washington",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "SMF",
        "name": "Sacramento International",
        "cityCode": "SAC",
        "cityName": "Sacramento",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "SLC",
        "name": "Salt Lake City",
        "cityCode": "SLC",
        "cityName": "Salt Lake City",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "SAN",
        "name": "San Diego International",
        "cityCode": "SAN",
        "cityName": "San Diego",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FRA", "FAO", "LIS", "PDL", "FNC", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "SFO",
        "name": "San Francisco",
        "cityCode": "SFO",
        "cityName": "San Francisco",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FRA", "LIS", "PDL", "FNC", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "SMA",
        "name": "Santa Maria",
        "cityCode": "SMA",
        "cityName": "Santa Maria Island (Azores)",
        "countryCode": "PT",
        "countryName": "Portugal",
        "regionName": "Azores",
        "x": 0,
        "y": 0,
        "azores": true,
        "airlineOperated": true,
        "destinations": ["TER", "JAX", "YOW", "MXP", "YXE", "CLT", "YXJ", "SLC", "STT", "DFW", "YXT", "YXS", "STX", "YXX", "TFN", "TFS", "YYC", "YYG", "PWM", "YYF", "LGA", "HOR", "YHZ", "LON", "YQB", "YYJ", "BCN", "SMF", "IAD", "SEA", "YQG", "HOU", "MAD", "FCO", "YQM", "YYT", "RSW", "YQQ", "YQR", "YYZ", "LPA", "YQU", "YQT", "ARN", "LGW", "BDA", "YQY", "YQX", "CVU", "TPA", "YAM", "YZF", "BTV", "PXO", "FLL", "HPN", "VLC", "SVO", "SVQ", "FLW", "ABQ", "HYA", "BUF", "PHL", "VDE", "LHR", "FUE", "SFL", "SFO", "BUR", "PHX", "RDU", "SWF", "ACE", "YSB", "MSP", "YKA", "BVC", "MSY", "LIS", "MCO", "FNC", "PIT", "CPH", "YCD", "PIX", "LAS", "LAX", "CHI", "SPC", "JFK", "OPO", "CHS", "RNO", "BWI", "YTO", "YTS", "MUC", "YDF", "YTZ", "AUS", "MDW", "DCA", "YLW", "BOS", "ROC", "AMS", "PSP", "SYR", "SID", "YUL", "OAK", "YMM", "YEG", "TCI", "ORD", "SAN", "VXE", "ORH", "DTW", "WAS", "SAV", "GRW", "SJC", "MVY", "SRQ", "YVR", "ORY", "YFC", "PDL", "NYC", "EWR", "SJZ", "PDX", "YWG", "BIO", "AGP", "DEN", "RIC", "FRA", "FAO", "RAI", "CLE", "PVD"],
        "partnerAirport": false
    }, {
        "code": "YXE",
        "name": "Saskatoon",
        "cityCode": "YXE",
        "cityName": "Saskatoon",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YAM",
        "name": "Sault Ste Marie",
        "cityCode": "YAM",
        "cityName": "Sault Ste. Marie",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "PIX"],
        "partnerAirport": false
    }, {
        "code": "SAV",
        "name": "Savannah/Hilton Head",
        "cityCode": "SAV",
        "cityName": "Savannah",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "SEA",
        "name": "Seattle/Tacoma",
        "cityCode": "SEA",
        "cityName": "Seattle",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FRA", "FAO", "LIS", "PDL", "FNC", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "SVQ",
        "name": "Sevilla",
        "cityCode": "SVQ",
        "cityName": "Seville",
        "countryCode": "ES",
        "countryName": "Spain",
        "regionName": "Europe",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "FLW", "YUL", "YTO", "PDL", "FNC", "YYZ", "PIX", "YTZ"],
        "partnerAirport": false
    }, {
        "code": "SVO",
        "name": "Sheremetyevo",
        "cityCode": "MOW",
        "cityName": "Moscow",
        "countryCode": "RU",
        "countryName": "Russia",
        "regionName": "Europe",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "RSW",
        "name": "Southwest Florida International",
        "cityCode": "FMY",
        "cityName": "Fort Myers",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "YYT",
        "name": "St. John\u0027s",
        "cityCode": "YYT",
        "cityName": "St. Johns",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "PIX"],
        "partnerAirport": false
    }, {
        "code": "SWF",
        "name": "Stewart International",
        "cityCode": "SWF",
        "cityName": "Newburgh",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "YSB",
        "name": "Sudbury",
        "cityCode": "YSB",
        "cityName": "Sudbury",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YQY",
        "name": "Sydney / J.A. Douglas McCurdy",
        "cityCode": "YQY",
        "cityName": "Sydney",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "RAI", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "SYR",
        "name": "Syracuse Hancock",
        "cityCode": "SYR",
        "cityName": "Syracuse",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "SFL",
        "name": "São Filipe Airport",
        "cityCode": "SFL",
        "cityName": "São Filipe",
        "countryCode": "CV",
        "countryName": "Cape Verde",
        "regionName": "Africa",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "FLW", "SJZ", "CVU", "SMA", "BOS", "PDL", "HOR", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "SJZ",
        "name": "São Jorge",
        "cityCode": "SJZ",
        "cityName": "Sao Jorge Island (Azores)",
        "countryCode": "PT",
        "countryName": "Portugal",
        "regionName": "Azores",
        "x": 0,
        "y": 0,
        "azores": true,
        "airlineOperated": true,
        "destinations": ["TER", "JAX", "YOW", "MXP", "YXE", "CLT", "YXJ", "SLC", "STT", "DFW", "YXT", "YXS", "STX", "YXX", "TFN", "TFS", "YYC", "SMA", "YYG", "PWM", "YYF", "LGA", "HOR", "YHZ", "LON", "YQB", "YYJ", "BCN", "SMF", "IAD", "SEA", "YQG", "HOU", "MAD", "FCO", "YQM", "YYT", "RSW", "YQQ", "YQR", "YYZ", "LPA", "YQU", "YQT", "ARN", "LGW", "BDA", "YQY", "YQX", "CVU", "TPA", "YAM", "YZF", "BTV", "PXO", "FLL", "HPN", "VLC", "SVO", "FLW", "ABQ", "HYA", "BUF", "PHL", "VDE", "LHR", "FUE", "SFL", "SFO", "BUR", "PHX", "RDU", "SWF", "ACE", "YSB", "MSP", "YKA", "BVC", "MSY", "LIS", "MCO", "FNC", "PIT", "CPH", "YCD", "PIX", "LAS", "LAX", "CHI", "SPC", "JFK", "OPO", "CHS", "RNO", "BWI", "YTO", "YTS", "MUC", "YDF", "YTZ", "AUS", "MDW", "DCA", "YLW", "BOS", "ROC", "AMS", "PSP", "SYR", "SID", "YUL", "OAK", "YMM", "YEG", "TCI", "ORD", "SAN", "VXE", "ORH", "DTW", "WAS", "SAV", "GRW", "SJC", "MVY", "SRQ", "YVR", "ORY", "YFC", "PDL", "NYC", "EWR", "PDX", "YWG", "AGP", "DEN", "RIC", "FRA", "FAO", "RAI", "CLE", "PVD"],
        "partnerAirport": false
    }, {
        "code": "TPA",
        "name": "Tampa International",
        "cityCode": "TPA",
        "cityName": "Tampa",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "TCI",
        "name": "Tenerife (All Airports)",
        "cityCode": "TCI",
        "cityName": "Tenerife",
        "countryCode": "ES",
        "countryName": "Spain",
        "regionName": "Europe",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "PDL", "HOR", "FNC", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "TFN",
        "name": "Tenerife Norte",
        "cityCode": "TCI",
        "cityName": "Tenerife",
        "countryCode": "ES",
        "countryName": "Spain",
        "regionName": "Europe",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "PDL", "HOR", "FNC", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "TFS",
        "name": "Tenerife South",
        "cityCode": "TCI",
        "cityName": "Tenerife",
        "countryCode": "ES",
        "countryName": "Spain",
        "regionName": "Europe",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "PDL", "HOR", "FNC", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "TER",
        "name": "Terceira",
        "cityCode": "TER",
        "cityName": "Terceira Island (Azores)",
        "countryCode": "PT",
        "countryName": "Portugal",
        "regionName": "Azores",
        "x": 0,
        "y": 0,
        "azores": true,
        "airlineOperated": true,
        "destinations": ["JAX", "YOW", "MXP", "YXE", "CLT", "YXJ", "SLC", "STT", "DFW", "YXT", "YXS", "STX", "YXX", "TFN", "TFS", "YYC", "SMA", "LGB", "YYG", "PWM", "YYF", "LGA", "HOR", "YHZ", "LON", "YQB", "YYJ", "BCN", "SMF", "IAD", "SEA", "YQG", "HOU", "MAD", "FCO", "YQM", "YYT", "RSW", "YQQ", "YQR", "YYZ", "LPA", "YQU", "YQT", "ARN", "LGW", "BDA", "YQY", "YQX", "CVU", "TPA", "YAM", "YZF", "BTV", "PXO", "FLL", "HPN", "VLC", "SVO", "SVQ", "FLW", "ABQ", "HYA", "BUF", "PHL", "VDE", "LHR", "FUE", "SFL", "SFO", "BUR", "PHX", "RDU", "SWF", "ACE", "YSB", "MSP", "YKA", "BVC", "MSY", "LIS", "MCO", "FNC", "PIT", "CPH", "YCD", "PIX", "LAS", "LAX", "CHI", "SPC", "JFK", "OPO", "CHS", "RNO", "BWI", "YTO", "YTS", "MUC", "YDF", "YTZ", "AUS", "MDW", "DCA", "YLW", "BOS", "ROC", "AMS", "PSP", "SYR", "SID", "YUL", "OAK", "YMM", "YEG", "TCI", "ORD", "SAN", "VXE", "ORH", "DTW", "WAS", "SAV", "GRW", "SJC", "MVY", "SRQ", "YVR", "ORY", "YFC", "PDL", "NYC", "EWR", "SJZ", "PDX", "YWG", "BIO", "AGP", "DEN", "RIC", "FRA", "FAO", "RAI", "CLE", "PVD"],
        "partnerAirport": false
    }, {
        "code": "YXT",
        "name": "Terrace",
        "cityCode": "YXT",
        "cityName": "Terrace",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "RAI", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YQT",
        "name": "Thunder Bay",
        "cityCode": "YQT",
        "cityName": "Thunder Bay",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YTS",
        "name": "Timmins",
        "cityCode": "YTS",
        "cityName": "Timmins",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "YTO",
        "name": "Toronto (All Airports)",
        "cityCode": "YTO",
        "cityName": "Toronto",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "VXE", "CVU", "MXP", "VLC", "GRW", "OPO", "SVQ", "FLW", "ZRH", "LHR", "ORY", "PDL", "MUC", "SJZ", "SMA", "AMS", "BIO", "HOR", "AGP", "LON", "BCN", "SID", "MAD", "FCO", "FRA", "FAO", "LIS", "FNC", "CPH", "RAI", "LPA", "ARN", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "VLC",
        "name": "Valencia",
        "cityCode": "VLC",
        "cityName": "Valencia",
        "countryCode": "ES",
        "countryName": "Spain",
        "regionName": "Europe",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "YUL", "SJZ", "CVU", "SMA", "BOS", "PDL", "HOR", "FNC", "YYZ", "GRW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YVR",
        "name": "Vancouver International",
        "cityCode": "YVR",
        "cityName": "Vancouver",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YYJ",
        "name": "Victoria International",
        "cityCode": "YYJ",
        "cityName": "Victoria",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "WAS",
        "name": "Washington (All Airports)",
        "cityCode": "WAS",
        "cityName": "Washington",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "IAD",
        "name": "Washington Dulles",
        "cityCode": "WAS",
        "cityName": "Washington",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "PBI",
        "name": "West Palm Beach",
        "cityCode": "PBI",
        "cityName": "West Palm Beach",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "LIS", "PDL", "OPO"],
        "partnerAirport": false
    }, {
        "code": "HPN",
        "name": "Westchester County",
        "cityCode": "HPN",
        "cityName": "Westchester",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "HOU",
        "name": "William P Hobby",
        "cityCode": "HOU",
        "cityName": "Houston",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "YQG",
        "name": "Windsor",
        "cityCode": "YQG",
        "cityName": "Windsor",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "YWG",
        "name": "Winnipeg J. Armstrong Rich.",
        "cityCode": "YWG",
        "cityName": "Winnipeg",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "LPA", "PIX"],
        "partnerAirport": false
    }, {
        "code": "ORH",
        "name": "Worcester Regional",
        "cityCode": "ORH",
        "cityName": "Worcester",
        "countryCode": "US",
        "countryName": "United States",
        "regionName": "United States",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["FLW", "TER", "SJZ", "CVU", "FAO", "SMA", "LIS", "PDL", "HOR", "GRW", "PIX", "OPO"],
        "partnerAirport": false
    }, {
        "code": "YZF",
        "name": "Yellowknife",
        "cityCode": "YZF",
        "cityName": "Yellowknife",
        "countryCode": "CA",
        "countryName": "Canada",
        "regionName": "Canada",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["TER", "SJZ", "CVU", "SMA", "HOR", "BCN", "GRW", "OPO", "FLW", "FAO", "LIS", "PDL", "FNC", "RAI", "LPA", "LGW", "PIX"],
        "partnerAirport": false
    }, {
        "code": "ZRH",
        "name": "Zürich",
        "cityCode": "ZRH",
        "cityName": "Zurich",
        "countryCode": "CH",
        "countryName": "Switzerland",
        "regionName": "Europe",
        "x": 0,
        "y": 0,
        "azores": false,
        "airlineOperated": false,
        "destinations": ["YUL", "BOS", "YYZ"],
        "partnerAirport": false
    }]
};
